import React from 'react';
import { Link, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import ReactPaginate from 'react-paginate';
import Modal from 'react-modal';
import DropdownBtn from '_components/utils/DropdownBtn';
import CreatableAsyncSelect from '_components/utils/CreatableAsyncSelect/CreatableAsyncSelect';
import { handleErrorResponse } from '_helpers/helpers';
import { redirectToPdf } from '_helpers/redirectToPdf';
import { formatDate } from '_helpers/helpers';
import { preventNegativeValueInDocs } from '_helpers/helpers';
import './ResourceDetails.css';
import {
  resourceActions,
  manifestActions,
  permissionActions,
  assignmentStatsActions,
  userActions,
  inventoryActions,
  dashboardActions,
} from '../_actions';
import '../assets/styles/resource.css';
import { authHeader, config, inventoryPicSrc, inventoryCategoryFallbackSrc } from '../_helpers';
import { manifestService, resourceService } from '_services';
import { Document, Page } from 'react-pdf';
import ReactModal from 'react-modal';
import { AlertPopup } from '../_components/AlertPopup';
import Accordian from '_components/Accordian';
import EmployeeList from 'Employees/EmployeeList';
import '../assets/styles/your-crew.css';
import AllManifest from '_components/AllManifest';
import RadioButton from 'Docs/Components/RadioButton';
import FireHistoryEmployeeAssignDragAndDrop from 'Resources/FireHistoryEmployeeAssignDragAndDrop';
import { getCurrentDatePST } from '_helpers/helpers';
import AsyncSelect from 'react-select/async';
import CustomToolTip from '_components/CustomToolTip';
import EmailManifestModal from '_components/EmailManifestModal';
import PropTypes from 'prop-types';
import { isManifestEditable } from '../_utils/utils';
// a little function to help us with reordering the result
ReactModal.setAppElement('#app');

const unDefined = 'undefined';

const currentDate = getCurrentDatePST();

const MENU_WIDTH = 300;

const selectStyles = {
  control: (css) => ({
    ...css,
    width: MENU_WIDTH || 'auto',
    opacity: MENU_WIDTH ? 1 : 0,
    zIndex: 9999,
  }),
  menuPortal: (provided) => ({ ...provided, zIndex: 9999 }),
  menu: (provided) => ({
    ...provided,
    opacity: MENU_WIDTH ? 1 : 0,
    zIndex: 9999,
  }),
  option: (css) => ({ ...css, paddingRight: 36 + 8, zIndex: 9999 }),
};

const FIRE_HISTORY_TYPE_SLUG = {
  WITH_MANIFEST: 'with_manifest',
  AUTO_ASSIGN_MANIFEST: 'auto_assign',
  MANUAL_ASSIGN_MANIFEST: 'manual_assign',
};

const assignmentStatuses = [
  { label: 'Assignment Status', value: '' },
  { label: 'Available', value: 'Available' },
  { label: 'Unavailable', value: 'Unavailable' },
];

const RESOURCE_ORDER_FILE_TYPE = {
  CREATE_FORM: 1,
  UPLOADED_FORM: 2,
};

class ResourceDetails extends React.Component {
  constructor(props) {
    super(props);
    this.sortYourCrewRef = React.createRef();
    this.manifestTableRef = React.createRef();
    this.state = {
      typeSlug: FIRE_HISTORY_TYPE_SLUG?.AUTO_ASSIGN_MANIFEST,
      editMode: false,
      keyword: '',
      id: this.props.props,
      mailFireCardsList: [],
      dispatchMailList: [],
      mailListDefault: [],
      mailList: [],
      searchList: [],
      emailOpen: false,
      emailFireCardsOpen: false,
      viewOpen: false,
      statusOpen: false,
      deleteOpen: false,
      textarea: true,
      search: false,
      linkClick: false,
      mid: '',
      action: 'hide',
      action_id: '',
      viewStatus: false,
      hideSearch: 'hide',
      pageNumber: 1,
      to: '',
      employeeList: [],
      flag: true,
      resultData: [],
      alertPop: false,
      resource_name: '',
      inputValue: false,
      emailSuccess: '',
      manifestPageNum: 1,
      assignmentStatusOptions: [
        'Available',
        'Unavailable',
        'Committed',
        'Archived',
      ],
      currentAssignmentStatus: 'Available', //varible to save current assignment status
      resourceAvailabilityStatus: 'available', // API resource availability status
      unavailabilityDetails: null, // Unavailability details from API
      tempAssignmentStatus: '', //varible to save assignment status when the user change in the popup , for displaying the form fields based on the selection
      currentProjectDetails: [], //array to store all details about current project
      unavailable_reason_id: '',
      unavailable_reasons: [],
      onDate: moment(currentDate),
      offDate: '',
      unavailable_start_date: '',
      unavailable_end_date: '',
      preventAssignmentPopupClick: false,
      formSubmission: false,
      currentAssignmentDetails: {
        name: '',
        date_off: '',
        date_on: '',
        assignment_type_id: '',
        assignment_type: '',
        shifts: '',
        notes: '',
        id: 0,
      },
      errorMessage: '',
      deleteHistoryOpen: false,
      historyId: '',
      assigmentCategoryOptions: [],
      assigmentStatusHistory: { data: [] },
      deletedManifestHistory: { data: [] },
      deletedHistoryPage: 1,
      deletedHistoryLastPage: 0,
      deletedHistoryPerPage: 15,
      deletedHistoryLoading: false,
      deletedManifests: { data: [] },
      deletedManifestsPage: 1,
      deletedManifestsLastPage: 0,
      deletedManifestsPerPage: 5,
      deletedManifestsLoading: false,
      restoreManifestLoading: false,
      resourceDetailsLoading: false,
      resourceOrderData: [],
      roPage: 0,
      roLastPage: 0,
      incidentProjects: [],
      projectId: null,
      projectName: '',
      projectNote: '',
      projectShift: '',
      tempAssignmentType: '',
      assignmentHistoryId: '',
      validManifestMail: false,
      manifestEmail: '',
      inventoryPage: 1,
      inventoryLastPage: 0,
      inventoryPerPage: 1,
      inventoryList: [],
      location: '',
      complexity: '',
      fuel_type: '',
      fire_size: '',
      hotline_shifts: '',
      deleteROModal: false,
      isCrewCommitted: false,
      printOption: '',
      selectedEmployees: [],
      confirmEditAssignment: false,
      displayEditAssignmentConfirmPopup: false,
      selectedResource: null,
      copySelectedResource: null,
      editROModal: false,
      selectedUploadedROFile: null,
      latestAssignmentHistory: null,
      manifestStatus: 'closedout',
      manifestCloseOutDateOff: null,
      manifestCloseOutHotlineShifts: '',
      manifestCloseOutNotes: '',
      isManifestCloseOut: false, // Flag to track if opened from manifest edit button
      emailManifestModalOpen: false, // Flag for email manifest modal
      commitManifestLoading: false, // Loading state for commit manifest
      vehiclesOption: [], // Array to store vehicle options
      restoreManifestModalOpen: false, // Flag for restore manifest confirmation modal
      manifestToRestore: null, // Store manifest ID to restore
    };

    this.handleSearch = this.handleSearch.bind(this);
    this.statusOpenModal = this.statusOpenModal.bind(this);
    this.statusCloseModal = this.statusCloseModal.bind(this);
    this.deleteOpenModal = this.deleteOpenModal.bind(this);
    this.deleteCloseModal = this.deleteCloseModal.bind(this);
    this.renderTotalShifts = this.renderTotalShifts.bind(this);
    this.handlePrintOption = this.handlePrintOption.bind(this);
    this.handleCancelEmailClick = this.handleCancelEmailClick.bind(this);
    this.onClickRemoveEmployeeFromMailList =
      this.onClickRemoveEmployeeFromMailList.bind(this);
    this.handleSelectEmployees = this.handleSelectEmployees.bind(this);
    this.handleOnWheel = this.handleOnWheel.bind(this);
    this.deleteHistoryCloseModal = this.deleteHistoryCloseModal.bind(this);

    this.emailOpenModal = this.emailOpenModal.bind(this);
    this.emailCloseModal = this.emailCloseModal.bind(this);
    this.emailFireCardsOpenModal = this.emailFireCardsOpenModal.bind(this);
    this.emailFireCardsCloseModal = this.emailFireCardsCloseModal.bind(this);
    this.viewOpenModal = this.viewOpenModal.bind(this);
    this.viewCloseModal = this.viewCloseModal.bind(this);
    this.keyUpFn = this.keyUpFn.bind(this);
    this.goBack = this.goBack.bind(this);
    this.remove = this.remove.bind(this);
    this.profile = this.profile.bind(this);
    this.editResource = this.editResource.bind(this);
    this.createManifest = this.createManifest.bind(this);
    this.printFireCards = this.printFireCards.bind(this);
    this.emailFireCards = this.emailFireCards.bind(this);
    this.editManifest = this.editManifest.bind(this);
    this.deleteManifest = this.deleteManifest.bind(this);
    this.printManifest = this.printManifest.bind(this);
    this.emailManifest = this.emailManifest.bind(this);
    this.sendMail = this.sendMail.bind(this);
    this.setMailer = this.setMailer.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.emailChangeFn = this.emailChangeFn.bind(this);
    this.removeList = this.removeList.bind(this);
    this.removeDispatchList = this.removeDispatchList.bind(this);
    this.viewManifest = this.viewManifest.bind(this);
    this.viewAction = this.viewAction.bind(this);
    this.onImageError = this.onImageError.bind(this);
    this.handleScroll = this.handleScroll.bind(this);
    this.closeAlert = this.closeAlert.bind(this);
    this.editResourceHistory = this.editResourceHistory.bind(this);
    this.selectProject = this.selectProject.bind(this);
    this.handleSelect = this.handleSelect.bind(this);
    this.addManifestEmail = this.addManifestEmail.bind(this);
    this.isValidEmail = this.isValidEmail.bind(this);
    this.inventoryPagination = this.inventoryPagination.bind(this);
    this.getInventoryList = this.getInventoryList.bind(this);
    this.getUnavailableReasons = this.getUnavailableReasons.bind(this);
    this.employeeListUpdated = this.employeeListUpdated.bind(this);
    this.handleChooseResources = this.handleChooseResources.bind(this);
    this.handleWindowFocus = this.handleWindowFocus.bind(this);
    this.getStatusClass = this.getStatusClass.bind(this);
    this.getStatusLabel = this.getStatusLabel.bind(this);
  }

  /**
   * Get CSS class name for manifest status
   * @param {string} status - Manifest availability status
   * @returns {string} CSS class name
   */
  getStatusClass = (status) => {
    switch (status) {
      case 'closedout':
        return 'red';
      case 'pending':
        return 'pending';
      case 'inuse':
      case 'available':
      default:
        return 'gray';
    }
  };

  /**
   * Get human-readable status label
   * @param {string} status - Manifest availability status
   * @returns {string} Status label
   */
  getStatusLabel = (status) => {
    switch (status) {
      case 'closedout':
        return 'Closed Out';
      case 'inuse':
        return 'In Use';
      case 'pending':
        return 'Pending';
      default:
        return 'Available';
    }
  };

  /**
   * Get human-readable manifest status label
   * @param {string} manifestStatus - Manifest status
   * @returns {string} Manifest status label
   */
  getManifestStatusLabel = (manifestStatus) => {
    if (!manifestStatus) {
      return '-';
    }
    switch (manifestStatus) {
      case 'inuse':
        return 'In Use';
      case 'closedout':
        return 'Closed Out';
      case 'pending':
        return 'Manifest Pending';
      default:
        return manifestStatus;
    }
  };

  handlePrintOption = (selectedOption) => {
    this.setState({ printOption: selectedOption });
  };

  handleCancelEmailClick = () => {
    this.setState({
      selectedEmployees: [],
      emailFireCardsOpen: false,
      printOption: '',
    });
  };

  onClickRemoveEmployeeFromMailList = (data) => {
    this.setState((prevState) => ({
      selectedEmployees: prevState.selectedEmployees.filter(
        (item) => item.label !== data.label,
      ),
    }));
  };

  handleSelectEmployees = (selected) => {
    // Filter out selected values that are already in the selectedEmployees array
    const uniqueSelected = selected.filter(
      (item) => !this.state.selectedEmployees.includes(item),
    );

    // Update selectedEmployees array by concatenating the unique selected values with the previous values
    this.setState((prevState) => ({
      selectedEmployees: prevState.selectedEmployees.concat(uniqueSelected),
    }));
  };

  statusOpenModal() {
    this.setState({ statusOpen: true, statusStep: '1' });
  }

  statusCloseModal() {
    this.setState({ statusOpen: false });
  }

  deleteOpenModal(id) {
    this.setState({ deleteOpen: true, mid: id });
  }

  deleteCloseModal() {
    this.setState({ deleteOpen: false });
  }

  deleteHistoryOpenModal = (id) => {
    this.setState({ deleteHistoryOpen: true, historyId: id });
  };

  handleEditRO = async () => {
    this.setState({
      formSubmission: true,
    });
    const data = new FormData();
    this.state.selectedResource.forEach((resource) => {
      data.append('resource_ids[]', resource.value);
    });

    this.props
      .dispatch(
        resourceActions.updateROResources(
          this.state.selectedUploadedROFile?.id,
          data,
        ),
      )
      .then((response) => {
        if (response.success) {
          this.getResourceOrderData(this.state.roPage + 1);
          toast.success(
            response.message || 'Resource order updated successfully.',
          );
          this.setState({
            editROModal: false,
            selectedResource: null,
          });
        } else {
          this.setState({
            selectedResource: this.state.copySelectedResource,
          });
          toast.error(
            'Failed to update RO - ' + response.message ||
            'An error occurred while updating the resource order.',
          );
        }
      })
      .catch((error) => {
        toast.error(error.message);
      });
    this.setState({
      formSubmission: false,
    });
  };

  deleteHistoryCloseModal() {
    this.setState({ deleteHistoryOpen: false, historyId: '' });
  }

  handleEditRof(rof_id) {
    let formData = new FormData();
    formData.append('rof_id', rof_id);
    manifestService?.getResourceOrderContent(formData).then(({ data }) => {
      if (data) {
        this.props.editRof(data?.[0]);
      }
    });
  }

  handleOnWheel = (e) => {
    e.preventDefault();
    e.stopPropagation();
    e.target.blur();
  };

  renderTotalShifts = (onDate, offDate) => {
    if (offDate && onDate) {
      const diffInDays =
        offDate.startOf('day').diff(onDate.startOf('day'), 'days') + 1;
      this.setState({ projectShift: diffInDays });
      return;
    }
    this.setState({ projectShift: '' });
    return;
  };

  handleDeleteRof = ({ id, type }) => {
    let formData = new FormData();
    formData.append('rof_id', id);
    formData.append('rof_type', type);
    manifestService
      ?.deleteResourceOrderPermanently(formData)
      .then(({ success, message }) => {
        this.setState({ deleteROModal: false });
        if (success) {
          toast.success(message);
          this.getResourceOrderData(this.state.roPage + 1);
          this.fetchData();
        } else {
          toast.error(message);
        }
      })
      .catch(() => { });
  };

  handleROPageChange = (newPage) => {
    const page = newPage?.selected + 1;
    this.getResourceOrderData(page);
    this.setState({ roPage: newPage?.selected });
  };

  // Helper method to get employee profile photo URL - uses asset URL + brand name for no_avatar
  getEmployeePhotoUrl(profilePhoto) {
    if (profilePhoto && profilePhoto.trim() !== '') {
      // For uploaded profile photos, use as-is from backend (no replacement)
      return profilePhoto;
    } else {
      // For no_avatar fallback, use asset URL + brand name
      const assetUrl = config.assetUrl;
      const assetBrandName = config.assetBrandName;
      if (assetUrl && assetBrandName && assetUrl.trim() !== '' && assetBrandName.trim() !== '') {
        return assetUrl.trim() + assetBrandName.trim() + '_no_avatar_profile.jpg';
      } else {
        return config.apiUrl + '/' + config.altImg;
      }
    }
  }

  // Helper method to get inventory photo URL with category-specific placeholder fallback
  getInventoryPhotoUrl(inventoryPic, inventoryItem) {
    if (inventoryPic && inventoryPic.trim() !== '') {
      return inventoryPicSrc(inventoryPic);
    } else {
      return inventoryCategoryFallbackSrc(inventoryItem);
    }
  }

  onInventoryImageError(item, e) {
    if (!item) return;
    const finalDefault = config.apiUrl + '/' + config.altImg;
    const fallback = inventoryCategoryFallbackSrc(item);
    const currentSrc = e.target.getAttribute('src') || '';
    if (currentSrc === finalDefault) return;

    if (currentSrc !== fallback && !e.target.dataset.fallbackAttempted) {
      e.target.setAttribute('src', fallback);
      e.target.dataset.fallbackAttempted = 'true';
    } else if (currentSrc === fallback) {
      e.target.setAttribute('src', finalDefault);
    }
  }

  onImageError(e) {
    // Use asset URL with brand name for no_avatar image (matches backend pattern)
    const assetUrl = config.assetUrl;
    const assetBrandName = config.assetBrandName;
    let noAvatarUrl;
    if (assetUrl && assetBrandName && assetUrl.trim() !== '' && assetBrandName.trim() !== '') {
      noAvatarUrl = assetUrl.trim() + assetBrandName.trim() + '_no_avatar_profile.jpg';
    } else {
      noAvatarUrl = config.apiUrl + '/' + config.altImg;
    }
    if (e.target.getAttribute('src') !== noAvatarUrl) {
      e.target.setAttribute('src', noAvatarUrl);
    }
  }

  isValidEmail(email) {
    let re = new RegExp(
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    );

    return re.test(email);
  }

  viewOpenModal(id) {
    this.setState({ viewOpen: true, mid: id });
  }

  viewCloseModal() {
    this.setState({ viewOpen: false });
  }

  emailOpenModal() {
    this.setState({
      emailOpen: true,
      mailListDefault: this.state.dispatchMailList,
    });
  }

  emailFireCardsOpenModal() {
    this.setState({
      emailFireCardsOpen: true,
    });
  }

  closeAlert() {
    this.setState({
      alertPop: false,
    });
  }

  emailCloseModal() {
    this.setState({ emailOpen: false });
    this.setState({ mailList: [], textarea: true, to: '' });
    document.getElementById('txtSearchManiEmployees').value = '';
    // document.getElementById('multiple_emails').value = "";
  }

  emailFireCardsCloseModal() {
    this.setState({ emailFireCardsOpen: false });
    this.setState({
      mailFireCardsList: [],
      textarea: true,
      to: '',
      selectedEmployees: [],
    });
  }
  viewAction(id) {
    // If clicking on the same item, close it. Otherwise, open the new one.
    if (this.state.action_id === id && this.state.viewStatus) {
      this.setState({
        action_id: '',
        action: 'hide',
        viewStatus: false,
      });
    } else {
      this.setState({
        action_id: id,
        action: 'show',
        viewStatus: true,
      });
    }
  }

  inventoryPagination() {
    if (this.state.inventoryList?.length > 0) {
      let pages = [];
      // let totalPages = Math.ceil(x / y);
      let currentPage = this.state.inventoryPage;
      let startingIndex = currentPage - 2 > 0 ? currentPage - 2 : 1;
      let lastPageIndex =
        currentPage + 2 < this.state.inventoryLastPage
          ? currentPage + 2
          : this.state.inventoryLastPage;
      let nextPage =
        currentPage + 1 > this.state.inventoryLastPage
          ? this.state.inventoryLastPage
          : currentPage + 1;
      let prevPage = currentPage - 1 > 0 ? currentPage - 1 : 1;

      if (currentPage > 3) {
        pages.push(
          <li
            className='inactive'
            key={0}
            onClick={() => {
              this.getInventoryList(1);
            }}
          >
            <a>1</a>
          </li>,
        );
      }
      if (currentPage > 4) {
        pages.push(
          <li className='inactive' key={1}>
            <a>. . .</a>
          </li>,
        );
      }
      for (let i = startingIndex; i <= lastPageIndex; i++) {
        // getManifestList
        pages.push(
          <li
            className={i == currentPage ? 'active' : 'inactive'}
            key={i}
            onClick={() => {
              this.getInventoryList(i);
            }}
          >
            <a>{i}</a>
          </li>,
        );
      }
      if (lastPageIndex + 1 < this.state.inventoryLastPage) {
        pages.push(
          <li className='inactive' key={this.state.inventoryLastPage + 1}>
            <a>. . .</a>
          </li>,
        );
      }
      if (lastPageIndex < this.state.inventoryLastPage) {
        pages.push(
          <li
            className='inactive'
            key={this.state.inventoryLastPage}
            onClick={() => {
              this.getInventoryList(this.state.inventoryLastPage);
            }}
          >
            <a>{this.state.inventoryLastPage}</a>
          </li>,
        );
      }

      if (pages?.length > 0) {
        return (
          <div
            className='fs-pagination-wrapper-outer custome_old_pagination'
            key={7}
          >
            <div className='fs-pagination-wrapper'>
              <span
                className={`prev ${prevPage === 1 && currentPage === 1 ? 'disabled' : ''
                  }`}
                onClick={() => {
                  this.getInventoryList(prevPage);
                }}
              >
                <img
                  alt='previous'
                  src={require('../assets/icons/next_arrow.svg').default}
                />
              </span>
              <ul className='fs-pagination'>{pages}</ul>
              <span
                className={`next ${nextPage == this.state.assigmentStatusHistory.data.last_page
                    ? 'disabled'
                    : ''
                  }`}
                onClick={() => {
                  this.getInventoryList(nextPage);
                }}
              >
                <img
                  alt='previous'
                  src={require('../assets/icons/next_arrow.svg').default}
                />
              </span>
            </div>
          </div>
        );
      }
    } else {
      return (
        <div className='applicant_item' key='noEmployees'>
          <p>No Inventory Assigned!</p>
        </div>
      );
    }
  }

  editResourceHistory(item) {
    let assignment = this.state.assigmentStatusHistory.data.find(
      (i) => i.id === item.id,
    );
    this.setState({
      unavailable_end_date: null,
      offDate: null,
    });

    if (assignment) {
      let { id, status, incident_projects, notes, resource_unavailability } =
        assignment;
      if (status == 3) {
        this.setState({
          editMode: true,
          preventAssignmentPopupClick: false,
          assignmentHistoryId: id,
          tempAssignmentStatus: this.state.assignmentStatusOptions[status - 1],
          tempAssignmentType: incident_projects.assignment_type_id,
          initialStatusId: status,
          projectId: incident_projects.id,
          projectName: incident_projects.name || '',
          projectShift: incident_projects.shifts || '',
          onDate: moment(incident_projects.date_on),
          offDate: incident_projects.date_off
            ? moment(incident_projects.date_off)
            : null,
          projectNote: notes || '',
          location: incident_projects.location || '',
          complexity: incident_projects.complexity || '',
          fuel_type: incident_projects.fuel_type || '',
          fire_size: incident_projects.fire_size || '',
          hotline_shifts: incident_projects.hotline_shifts || '',
        });
      } else if (status == 2) {
        this.setState({
          editMode: true,
          preventAssignmentPopupClick: false,
          assignmentHistoryId: id,
          tempAssignmentStatus: this.state.assignmentStatusOptions[status - 1],
          unavailable_reason_id: resource_unavailability.unavailable_reason_id,
          unavailable_start_date: moment(resource_unavailability.start_date),
          unavailable_end_date: resource_unavailability.end_date
            ? moment(resource_unavailability.end_date)
            : '',
          initialStatusId: status,
          projectNote: notes || '',
        });
      }

      document.body.className += ' ' + 'inv-sidebar-opened';
    }
  }

  getInventoryList(page) {
    let { inventoryLastPage } = this.state;
    if (page && page >= 1 && page <= inventoryLastPage) {
      this.props
        .dispatch(
          inventoryActions.getPaginatedList({ id: this.state.id, page }),
        )
        .then((res) => {
          this.setState({
            inventoryPage: res.current_page,
            inventoryLastPage: res.last_page,
            inventoryPerPage: res.per_page,
          });
        });
    }
  }

  selectProject(e) {
    let id = e.target.value;
    this.setState({
      projectId: id || null,
    });
  }

  handleSelect(e) {
    this.setState({
      [e.target.name]: e.target.value,
    });
  }

  addManifestEmail() {
    if (this.state.validManifestMail) {
      this.setState({
        mailSearchKeyword: '',
        hideSearch: 'hide',
        mailList: [
          ...this.state.mailList,
          {
            first_name: '-',
            last_name: '-',
            email: this.state.manifestEmail,
          },
        ],
      });
    }
  }

  // get unavailable reasons
  getUnavailableReasons() {
    const _requestOptions = {
      method: 'GET',
      headers: authHeader(),
    };
    const _url = `${config.apiUrl}/api/getlist/unavailablereason`;
    fetch(_url, _requestOptions).then((response) =>
      response.json().then(
        (res) => {
          //
          this.setState({ unavailable_reasons: res });
        },
        (err) => { },
      ),
    );
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
    window.removeEventListener('focus', this.handleWindowFocus);
    var body = document.body;
    body.classList.remove('inv-sidebar-opened');
  }

  fetchData() {
    let data = new FormData();
    this.getUnavailableReasons();
    this.getResourceOrderData(1);
    this.props.dispatch(manifestActions.dispatchMailList());
    this.props.dispatch(resourceActions.getResourceDetails(this.props.props));
    this.props.dispatch(resourceActions.getProjects());
    this.props.dispatch(assignmentStatsActions.getAssignemntStatusTypes());
    this.props.dispatch(
      assignmentStatsActions.getAssignemntStatus(this.state.id),
    );
    this.props.dispatch(
      assignmentStatsActions.getAssignemntHistory(this.state.id, 1),
    );
    this.fetchDeletedManifestHistory(1);
    this.fetchDeletedManifests(1);

    data.append('crew_identifier_id', this.state.id);
    this.props.dispatch(resourceActions.getResourceVehicles(this.state.id));

    data.append('active', true);
    data.append('locked', true);
    data.append('guest', true);
    data.append('pagination', false);

    this.props.dispatch(resourceActions.employeeList(data));
    this.props.dispatch(permissionActions.getPermission());
    this.props.dispatch(userActions.getAll());

    let data2 = new FormData();
    data2.append('resource_id', this.state.id);
    this.getManifestList();
    this.props.dispatch(manifestActions.getVehicles(data2));
    this.props
      .dispatch(
        inventoryActions.getPaginatedList({ id: this.state.id, page: 1 }),
      )
      .then((res) => {
        this.setState({
          inventoryPage: res.current_page,
          inventoryLastPage: res.last_page,
          inventoryPerPage: res.per_page,
        });
      });

    this.props.dispatch(assignmentStatsActions.getAssignmentComplexity());
    this.props.dispatch(assignmentStatsActions.getAssignmentFireSize());
    this.props.dispatch(assignmentStatsActions.getAssignmentFuelType());

    // Set loading state immediately before fetching
    this.setState({ resourceDetailsLoading: true });

    // Fetch resource availability status at the end to ensure it's not overridden
    // Use setTimeout to ensure this runs after all other state updates
    setTimeout(() => {
      this.fetchResourceDetails();
    }, 100);
  }
  componentDidMount() {
    this.fetchData();
    window.addEventListener('focus', this.handleWindowFocus);
  }

  componentDidUpdate(prevProps, prevState) {
    const { printOption } = this.state;
    if (printOption !== prevState.printOption) {
      if (printOption === 'pdf') {
        this.printFireCards();
        setTimeout(() => {
          this.setState({ printOption: null });
        }, 1000);
      } else if (printOption === 'email') {
        this.setState({ emailFireCardsOpen: true });
      }
    }
  }

  handleWindowFocus() {
    if (document.hidden) {
      return;
    }

    if (this.state.id) {
      this.props.dispatch(
        assignmentStatsActions.getAssignemntHistory(this.state.id, 1),
      );
    }
  }

  // Unified method to fetch Resource Orders with proper pagination
  async getResourceOrderData(page = 1) {
    try {
      const data = {
        resourceId: this.state.id,
        perPage: 5,
        page: page,
      };

      const response = await this.props.dispatch(
        resourceActions.getResourceOrderForms(data),
      );

      if (response?.data?.data) {
        const resourceOrders = response.data.data.map((item) => ({
          ...item,
          id: item.resourceOrderId, // Map resourceOrderId to id for consistency
          displayName: item.ro_name,
          created_at: item.created_date,
          sortDate: new Date(item.created_date),
          resources: item.resource_name
            ? [{ resource_name: item.resource_name }]
            : [],
        }));

        this.setState({
          resourceOrderData: resourceOrders,
          roLastPage: response.data.last_page || 1,
          roPage: response.data.current_page - 1 || 0,
        });
      }
    } catch (error) {
      console.error('Error fetching resource order data:', error);
    }
  }

  // View created RO
  viewCreatedRO = (rofId) => {
    let data = new FormData();
    data.append('rof_id', rofId);
    manifestService
      ?.viewResourceOrderForm(data)
      .then((response) => this.redirectToPdf(response));
  };

  redirectToPdf = (data) => {
    if (data?.success) {
      const pdfLink = data.data;
      var link = document.createElement('a');
      if (
        window.navigator.userAgent.match(/iPad/i) ||
        window.navigator.userAgent.match(/iPhone/i)
      ) {
        link.href = pdfLink;
      } else {
        link.href = pdfLink;
        link.target = '_blank';
      }
      document.body.appendChild(link);
      link.click();
      setTimeout(function () {
        document.body.removeChild(link);
        // For Firefox it is necessary to delay revoking the ObjectURL
        window.URL.revokeObjectURL(pdfLink);
      }, 100);
    }
  };

  // call after doing some actions in EmployeeList
  employeeListUpdated() {
    let data = new FormData();
    data.append('crew_identifier_id', this.state.id);
    data.append('active', true);
    data.append('locked', true);
    data.append('guest', true);
    data.append('pagination', false);
    this.props.dispatch(resourceActions.employeeList(data));
  }

  getManifestList = (manifestPageNum = 1) => {
    const data = {
      resourceId: this.state.id,
      perPage: 5,
      page: manifestPageNum,
    };
    this.props.dispatch(manifestActions.manifestListV1(data));

    // Scroll to top of manifest table when pagination changes
    if (manifestPageNum > 1 && this.manifestTableRef.current) {
      setTimeout(() => {
        this.manifestTableRef.current.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      }, 100);
    }
  };

  fetchResourceDetails = () => {
    manifestService
      .getResourceDetails(this.state.id)
      .then((response) => {
        if (response.status === 'success') {
          const resourceData = response.data;

          // Use the API's resource_availability_status directly
          let currentAssignmentStatus = 'Available'; // Default status

          // Map the API status to display status
          switch (resourceData.resource_availability_status) {
            case 'available':
              currentAssignmentStatus = 'Available';
              break;
            case 'unavailable':
              currentAssignmentStatus = 'Unavailable';
              break;
            case 'committed':
              currentAssignmentStatus = 'Committed';
              break;
            default:
              currentAssignmentStatus = 'Available';
          }

          this.setState(
            {
              currentAssignmentStatus,
              resourceAvailabilityStatus:
                resourceData.resource_availability_status,
              unavailabilityDetails: resourceData.unavailability_details,
              resourceDetailsLoading: false,
            },
            () => { },
          );
        } else {
          this.setState({ resourceDetailsLoading: false });
        }
      })
      .catch((error) => {
        console.error('Error fetching resource details:', error);
        // Fallback to default status if API fails
        this.setState({
          currentAssignmentStatus: 'Available',
          resourceAvailabilityStatus: 'available',
          unavailabilityDetails: null,
          resourceDetailsLoading: false,
        });
      });
  };

  fetchDeletedManifestHistory = (page = 1) => {
    this.setState({ deletedHistoryLoading: true });

    manifestService
      .getDeletedManifestHistory(
        this.state.id,
        this.state.deletedHistoryPerPage,
        page,
      )
      .then((response) => {
        if (response.status === 'success') {
          this.setState({
            deletedManifestHistory: response.data.deletedAssignmentHistory,
            deletedHistoryPage:
              response.data.deletedAssignmentHistory.current_page,
            deletedHistoryLastPage:
              response.data.deletedAssignmentHistory.last_page,
            deletedHistoryLoading: false,
          });
        } else {
          this.setState({ deletedHistoryLoading: false });
        }
      })
      .catch((error) => {
        console.error('Error fetching deleted manifest history:', error);
        this.setState({ deletedHistoryLoading: false });
      });
  };

  getDeletedHistoryPaginationHtml = () => {
    let paginationHtml = [];

    if (this.state.deletedManifestHistory?.data?.length > 0) {
      let pages = [];
      let currentPage = this.state.deletedHistoryPage;
      let startingIndex = currentPage - 2 > 0 ? currentPage - 2 : 1;
      let lastPageIndex =
        currentPage + 2 < this.state.deletedHistoryLastPage
          ? currentPage + 2
          : this.state.deletedHistoryLastPage;
      let nextPage =
        currentPage + 1 > this.state.deletedHistoryLastPage
          ? this.state.deletedHistoryLastPage
          : currentPage + 1;
      let prevPage = currentPage - 1 > 0 ? currentPage - 1 : 1;

      if (currentPage > 3) {
        pages.push(
          <li
            className='inactive'
            key={0}
            onClick={() => {
              this.fetchDeletedManifestHistory(1);
            }}
          >
            <a>1</a>
          </li>,
        );
      }
      if (currentPage > 4) {
        pages.push(
          <li className='inactive' key={1}>
            <a>. . .</a>
          </li>,
        );
      }
      for (let i = startingIndex; i <= lastPageIndex; i++) {
        pages.push(
          <li
            className={i == currentPage ? 'active' : 'inactive'}
            key={i}
            onClick={() => {
              this.fetchDeletedManifestHistory(i);
            }}
          >
            <a>{i}</a>
          </li>,
        );
      }
      if (lastPageIndex + 1 < this.state.deletedHistoryLastPage) {
        pages.push(
          <li className='inactive' key={this.state.deletedHistoryLastPage + 1}>
            <a>. . .</a>
          </li>,
        );
      }
      if (lastPageIndex < this.state.deletedHistoryLastPage) {
        pages.push(
          <li
            className='inactive'
            key={this.state.deletedHistoryLastPage}
            onClick={() => {
              this.fetchDeletedManifestHistory(
                this.state.deletedHistoryLastPage,
              );
            }}
          >
            <a>{this.state.deletedHistoryLastPage}</a>
          </li>,
        );
      }

      if (pages?.length > 0) {
        paginationHtml.push(
          <div
            className='fs-pagination-wrapper-outer custome_old_pagination'
            key={7}
          >
            <div className='fs-pagination-wrapper'>
              <span
                className={`prev ${prevPage === 1 && currentPage === 1 ? 'disabled' : ''
                  }`}
                onClick={() => {
                  this.fetchDeletedManifestHistory(prevPage);
                }}
              >
                <img
                  alt='previous'
                  src={require('../assets/icons/next_arrow.svg').default}
                />
              </span>
              <ul className='fs-pagination'>{pages}</ul>
              <span
                className={`next ${nextPage == this.state.deletedHistoryLastPage
                    ? 'disabled'
                    : ''
                  }`}
                onClick={() => {
                  this.fetchDeletedManifestHistory(nextPage);
                }}
              >
                <img
                  alt='next'
                  src={require('../assets/icons/next_arrow.svg').default}
                />
              </span>
            </div>
          </div>,
        );
      }
    }

    return paginationHtml;
  };

  fetchDeletedManifests = (page = 1) => {
    this.setState({ deletedManifestsLoading: true });

    manifestService
      .getDeletedManifests(
        this.state.id,
        this.state.deletedManifestsPerPage,
        page,
      )
      .then((response) => {
        if (response.status === 'success') {
          this.setState({
            deletedManifests: response.data,
            deletedManifestsPage: response.data.pagination.current_page,
            deletedManifestsLastPage: response.data.pagination.last_page,
            deletedManifestsLoading: false,
          });
        } else {
          this.setState({ deletedManifestsLoading: false });
        }
      })
      .catch((error) => {
        console.error('Error fetching deleted manifests:', error);
        this.setState({ deletedManifestsLoading: false });
      });
  };

  openRestoreManifestModal = (manifestId) => {
    this.setState({
      restoreManifestModalOpen: true,
      manifestToRestore: manifestId,
    });
  };

  closeRestoreManifestModal = () => {
    this.setState({ restoreManifestModalOpen: false, manifestToRestore: null });
  };

  handleRestoreManifest = () => {
    const manifestId = this.state.manifestToRestore;
    if (!manifestId) return;

    this.setState({
      restoreManifestLoading: true,
      restoreManifestModalOpen: false,
    });

    manifestService
      .restoreManifest(manifestId)
      .then((response) => {
        if (response.status === 'success') {
          this.setState({
            restoreManifestLoading: false,
            manifestToRestore: null,
            alertPop: true,
            alertHead: 'Success',
            alertMsg: 'Manifest restored successfully',
            alertFunction: '',
          });
          // Refresh both manifest lists
          this.getManifestList();
          this.fetchDeletedManifests(this.state.deletedManifestsPage);
        } else {
          this.setState({
            restoreManifestLoading: false,
            manifestToRestore: null,
            alertPop: true,
            alertHead: 'Error',
            alertMsg: response.message || 'Failed to restore manifest',
            alertFunction: '',
          });
        }
      })
      .catch((error) => {
        console.error('Error restoring manifest:', error);
        this.setState({
          restoreManifestLoading: false,
          manifestToRestore: null,
          alertPop: true,
          alertHead: 'Error',
          alertMsg: 'Failed to restore manifest',
          alertFunction: '',
        });
      });
  };

  getDeletedManifestsPaginationHtml = () => {
    let paginationHtml = [];

    if (this.state.deletedManifests?.data?.length > 0) {
      let pages = [];
      let currentPage = this.state.deletedManifestsPage;
      let startingIndex = currentPage - 2 > 0 ? currentPage - 2 : 1;
      let lastPageIndex =
        currentPage + 2 < this.state.deletedManifestsLastPage
          ? currentPage + 2
          : this.state.deletedManifestsLastPage;
      let nextPage =
        currentPage + 1 > this.state.deletedManifestsLastPage
          ? this.state.deletedManifestsLastPage
          : currentPage + 1;
      let prevPage = currentPage - 1 > 0 ? currentPage - 1 : 1;

      if (currentPage > 3) {
        pages.push(
          <li
            className='inactive'
            key={0}
            onClick={() => {
              this.fetchDeletedManifests(1);
            }}
          >
            <a>1</a>
          </li>,
        );
      }
      if (currentPage > 4) {
        pages.push(
          <li className='inactive' key={1}>
            <a>. . .</a>
          </li>,
        );
      }
      for (let i = startingIndex; i <= lastPageIndex; i++) {
        pages.push(
          <li
            className={i == currentPage ? 'active' : 'inactive'}
            key={i}
            onClick={() => {
              this.fetchDeletedManifests(i);
            }}
          >
            <a>{i}</a>
          </li>,
        );
      }
      if (lastPageIndex + 1 < this.state.deletedManifestsLastPage) {
        pages.push(
          <li
            className='inactive'
            key={this.state.deletedManifestsLastPage + 1}
          >
            <a>. . .</a>
          </li>,
        );
      }
      if (lastPageIndex < this.state.deletedManifestsLastPage) {
        pages.push(
          <li
            className='inactive'
            key={this.state.deletedManifestsLastPage}
            onClick={() => {
              this.fetchDeletedManifests(this.state.deletedManifestsLastPage);
            }}
          >
            <a>{this.state.deletedManifestsLastPage}</a>
          </li>,
        );
      }

      if (pages?.length > 0) {
        paginationHtml.push(
          <div
            className='fs-pagination-wrapper-outer custome_old_pagination'
            key={7}
          >
            <div className='fs-pagination-wrapper'>
              <span
                className={`prev ${prevPage === 1 && currentPage === 1 ? 'disabled' : ''
                  }`}
                onClick={() => {
                  this.fetchDeletedManifests(prevPage);
                }}
              >
                <img
                  alt='previous'
                  src={require('../assets/icons/next_arrow.svg').default}
                />
              </span>
              <ul className='fs-pagination'>{pages}</ul>
              <span
                className={`next ${nextPage == this.state.deletedManifestsLastPage
                    ? 'disabled'
                    : ''
                  }`}
                onClick={() => {
                  this.fetchDeletedManifests(nextPage);
                }}
              >
                <img
                  alt='next'
                  src={require('../assets/icons/next_arrow.svg').default}
                />
              </span>
            </div>
          </div>,
        );
      }
    }

    return paginationHtml;
  };

  createManifest() {
    this.props.createManifest();
  }

  isCreateManifestDisabled() {
    try {
      const resourceStatus = this.state?.resourceAvailabilityStatus;
      const manifestStatus = this.state?.manifestStatus;

      // Disable if resource is unavailable or committed
      if (resourceStatus === 'unavailable' || resourceStatus === 'committed') {
        return true;
      }
      // If resource is available, check if manifest is pending
      if (resourceStatus === 'available' && manifestStatus === 'pending') {
        return true;
      }
      return false;
    } catch (error) {
      return false;
    }
  }

  getCreateManifestTooltip() {
    try {
      const resourceStatus = this.state?.resourceAvailabilityStatus;
      const manifestStatus = this.state?.manifestStatus;

      if (resourceStatus === 'committed') {
        return 'You must close out the current manifest before creating a new one';
      }
      if (resourceStatus === 'unavailable') {
        return 'You must make the resource available before creating a new manifest';
      }
      if (resourceStatus === 'available' && manifestStatus === 'pending') {
        return 'You must commit the current manifest before creating a new one';
      }
      return '';
    } catch (error) {
      return '';
    }
  }
  printFireCards() {
    const { id, printOption, selectedEmployees } = this.state;
    let data = new FormData();
    data.append('crew_id', id);
    data.append('type', 'Crew');
    data.append('print', printOption);

    if (printOption == 'email') {
      selectedEmployees?.forEach((employee, index) => {
        data.append(`email[${index}]`, employee.email);
      });
    }
    resourceService
      .printFireCards(data)
      .then((res) => {
        if (printOption == 'pdf') {
          redirectToPdf(res);
        }
        if (res.success) {
          toast.success(res.message);
          this.setState({
            selectedEmployees: [],
            emailFireCardsOpen: false,
            printOption: '',
          });
        } else {
          handleErrorResponse(res);
        }
      })
      .catch((error) => {
        toast.error(error.message);
      });
  }

  editManifest(id, type) {
    this.props.editManifest(id, type);
  }

  duplicateManifest(manifest) {
    this.props.duplicateManifest(manifest);
  }

  deleteManifest = async () => {
    let data = new FormData();
    data.append('manifest_id', this.state.mid);
    let data2 = new FormData();
    data2.append('resource_id', this.state.id);
    await this.props.dispatch(manifestActions.deleteManifest(data, data2));
    this.fetchData();
    this.setState({ deleteOpen: false });
  };

  printFireCards(id) {
    // Extract manifest ID from action_id
    const manifestId = this.state.action_id.split('-')[0];

    var data =
      '?manifest_id=' +
      manifestId +
      '&crew_id=' +
      this.props.props +
      '&print=pdf' +
      '&type=Crew';
    const requestOptions = {
      method: 'POST',
      headers: authHeader(),
    };
    var self = this;
    fetch(config.apiUrl + '/api/getFireCards' + data, requestOptions)
      .then(function (res) {
        return res.json();
      })
      .then(function (data) {
        if (data.success) {
          const pdfLink = data.data;
          var link = document.createElement('a');
          if (
            window.navigator.userAgent.match(/iPad/i) ||
            window.navigator.userAgent.match(/iPhone/i)
          ) {
            link.href = pdfLink;
          } else {
            link.href = pdfLink;
            link.target = '_blank';
          }
          document.body.appendChild(link);
          link.click();
          setTimeout(function () {
            document.body.removeChild(link);
            // For Firefox it is necessary to delay revoking the ObjectURL
            window.URL.revokeObjectURL(pdfLink);
          }, 100);
        } else {
          self.setState({
            alertPop: true,
            alertHead: 'Error',
            alertMsg: data.message,
            alertFunction: '',
          });
        }
      });
  }

  emailFireCards() {
    // Extract manifest ID from action_id
    const manifestId = this.state.action_id.split('-')[0];

    let data = new FormData();
    data.append('manifest_id', manifestId);
    data.append('crew_id', this.props.props);
    data.append('print', 'email');
    data.append('type', 'Crew');

    this.state.selectedEmployees?.forEach((employee, index) => {
      data.append(`email[${index}]`, employee.email);
    });
    const requestOptions = {
      method: 'POST',
      headers: authHeader(),
      body: data,
    };

    resourceService
      .printFireCards(data)
      .then((res) => {
        if (res.success) {
          toast.success(res.message);
          this.setState({
            selectedEmployees: [],
            emailFireCardsOpen: false,
            printOption: '',
            action_id: '',
          });
        } else {
          handleErrorResponse(res);
        }
      })
      .catch((error) => {
        toast.error(error.message);
      });
  }

  printManifest(id) {
    // Extract manifest ID and version ID from action_id
    const actionIdParts = this.state.action_id.split('-');
    const manifestId = actionIdParts[0];
    const versionId = actionIdParts[1];

    var data =
      '?manifest_id=' + manifestId + '&resource_id=' + this.props.props;

    // Add version ID if it's not 'latest'
    if (versionId && versionId !== 'latest') {
      data += '&manifest_version_id=' + versionId;
    }

    const requestOptions = {
      method: 'POST',
      headers: authHeader(),
    };
    var self = this;
    fetch(config.apiUrl + '/api/manifest/pdf' + data, requestOptions)
      .then(function (res) {
        return res.json();
      })
      .then(function (data) {
        if (data.success) {
          const pdfLink = data.data;
          var link = document.createElement('a');
          if (
            window.navigator.userAgent.match(/iPad/i) ||
            window.navigator.userAgent.match(/iPhone/i)
          ) {
            link.href = pdfLink;
          } else {
            link.href = pdfLink;
            link.target = '_blank';
          }
          document.body.appendChild(link);
          link.click();
          setTimeout(function () {
            document.body.removeChild(link);
            // For Firefox it is necessary to delay revoking the ObjectURL
            window.URL.revokeObjectURL(pdfLink);
          }, 100);
        } else {
          self.setState({
            alertPop: true,
            alertHead: 'Error',
            alertMsg: data.message,
            alertFunction: '',
          });
        }
      });
  }

  emailManifest() {
    // Extract manifest ID from action_id
    const manifestId = this.state.action_id.split('-')[0];

    let data = new FormData();
    data.append('manifest_id', manifestId);
    data.append('resource_id', this.props.props);
    let toList = this.state.mailListDefault;

    if (this.state.mailList?.length > 0) {
      toList = [...toList, ...this.state.mailList.map((item) => item.email)];
    }

    data.append('to', toList.join());

    this.props.dispatch(manifestActions.emailManifest(data));
    this.props.details(this.props.props);
    this.setState({ emailOpen: false, emailSuccess: 'true' });

    this.setState({ mailList: [], textarea: true, to: '' });
    document.getElementById('txtSearchManiEmployees').value = '';
  }

  handleScroll(event) {
    var wrap = document.getElementById('right_sidebar'),
      contentHeight = wrap.offsetHeight,
      yOffset = window.pageYOffset,
      y = Math.ceil(yOffset + window.innerHeight),
      applicationItem = [],
      sortVariable = '';

    if (this.state.sort !== '' && this.state.sort) {
      sortVariable =
        '&sort=' + this.state.sort + '&order=' + this.state.orderAll
          ? this.state.orderAll
          : 'asc';
    }

    if (y >= contentHeight) {
      let data = this.state.resultData;

      let reqData = new FormData();
      reqData.append('crew_identifier_id', this.state.id);
      if (data.current_page < data.last_page && this.state.flag !== false) {
        const requestOptions = {
          method: 'POST',
          headers: authHeader(),
          body: reqData,
        };

        fetch(data.next_page_url + sortVariable, requestOptions)
          .then((res) => {
            return res.json();
          })
          .then((data) => {
            this.setState({ resultData: data.data });

            if (data.data.current_page === data.data.last_page) {
              this.setState({ flag: false });
            }

            var appInf = [];

            this.setState({
              employeeList: [...this.state.employeeList, ...data.data.data],
            });

            data.data.data.forEach((item, index) => {
              appInf[item.hash] = item.applicant_info;
              this.setState((state) => ({
                applicant_info: { ...state.applicant_info, ...appInf },
              }));

              applicationItem.push(
                <div className='employee_item'>
                  <div className='list_item image-holder second_width'>
                    <img
                      alt={item.first_name + ' ' + item.last_name}
                      className={item.active}
                      src={this.getEmployeePhotoUrl(item.profile_photo)}
                      onError={this.onImageError.bind(this)}
                    />
                  </div>
                  <div className='list_item second_width second_width'>
                    <span className={item.colorcode + ' color_code'} />
                    <span className='emp_name'>
                      {item.first_name + ' ' + item.last_name}
                    </span>
                  </div>
                  <div className='list_item second_width'>{item.email}</div>
                  <div
                    className='list_item sendMail_btn second_width'
                    onClick={this.sendMail.bind(this, item.email)}
                  >
                    Send Mail
                  </div>
                  <div
                    className='list_item close_mail second_width'
                    onClick={this.removeList.bind(this, item.email)}
                  >
                    <img
                      alt='close'
                      src={require('../assets/images/close_button.png').default}
                      onError={this.onImageError.bind(this)}
                    />
                  </div>
                </div>,
              );
            });

            this.setState({
              applicationItem: [
                ...this.state.applicationItem,
                ...applicationItem,
              ],
            });
          })
          .catch((err) => { });
      }
    }
  }
  /**
   * function to close slider to edit the assignment status
   */
  closeStatusPopup = (doNotReset) => {
    const wasManifestCloseOut = this.state.isManifestCloseOut;
    document.body.classList.remove('inv-sidebar-opened');

    if (!doNotReset) {
      this.setState({
        location: '',
        complexity: '',
        fuel_type: '',
        fire_size: '',
        hotline_shifts: '',
        isManifestCloseOut: false,
      });
    } else if (wasManifestCloseOut) {
      this.setState({ isManifestCloseOut: false });
    }

    if (wasManifestCloseOut && this.state.id) {
      this.props.dispatch(
        assignmentStatsActions.getAssignemntHistory(this.state.id, 1),
      );
    }
  };

  editAssignmentConfirmation = (e) => {
    this.setState(
      {
        displayEditAssignmentConfirmPopup: false,
        confirmEditAssignment: true,
      },
      () => {
        this.saveAssignmentChanges(e);
      },
    );
  };

  closeEditAssignmentConfirmPopup = () => {
    this.setState({
      displayEditAssignmentConfirmPopup: false,
    });
  };

  handleCloseManifest = async (data) => {
    try {
      this.setState({
        preventAssignmentPopupClick: true,
      });

      await this.props.dispatch(manifestActions.closeManifest(data));

      toast.success('Manifest closed out successfully!');
      this.closeStatusPopup();
      this.fetchData(); // Refresh data to get updated manifest status
    } catch (error) {
      toast.error('Failed to close out manifest');
      console.error('Manifest close out error:', error);
      this.setState({
        preventAssignmentPopupClick: false,
      });
    }
  };

  handleCommitManifest = async () => {
    try {
      this.setState({
        preventAssignmentPopupClick: true,
        commitManifestLoading: true,
      });

      // Get manifestId from fireHistoryManifestId or currentAssignmentDetails
      const manifestId =
        this.state.fireHistoryManifestId ||
        this.state.currentAssignmentDetails?.manifest_id;

      if (!manifestId) {
        this.setState({
          preventAssignmentPopupClick: false,
          commitManifestLoading: false,
        });
        return toast.error('Manifest ID is required.');
      }

      const payload = {
        manifestId: manifestId,
        resourceIdentifierId: this.state.id,
        dateOn: moment(this.state.onDate).format('YYYY-MM-DD'),
        assignmentType: Number(this.refs.AssignmentType.value),
        dateOff: this.state.offDate
          ? moment(this.state.offDate).format('YYYY-MM-DD')
          : null,
        shifts: this.state.projectShift || null,
        location: this.state.location || null,
        complexity: this.state.complexity || null,
        fuelType: this.state.fuel_type || null,
        fireSize: this.state.fire_size || null,
        hotlineShifts: null,
        notes: this.refs.note?.value || null,
      };

      const res = await fetch(
        config.apiUrl + '/api/v1/manifests/commit-manifest',
        {
          method: 'POST',
          headers: { ...authHeader(), 'Content-Type': 'application/json' },
          body: JSON.stringify(payload),
        },
      );

      const data = await res.json();

      if (data?.status === 'success') {
        toast.success('Manifest committed successfully!');

        // Reset loading state
        this.setState({
          preventAssignmentPopupClick: false,
          commitManifestLoading: false,
        });

        // Close status popup first
        this.closeStatusPopup();

        // Refresh data to get updated manifest status (but don't let it interfere with modal)
        this.fetchData();

        // Fetch dispatch mail list and open email manifest modal
        // Use setTimeout to ensure the status popup is closed and fetchData has started
        setTimeout(() => {
          // Fetch dispatch mail list
          this.props.dispatch(manifestActions.dispatchMailList());

          // Open email manifest modal
          this.setState({ emailManifestModalOpen: true });
        }, 500);
      } else {
        const errorMsg = data?.message || 'Failed to commit manifest';
        toast.error(
          typeof errorMsg === 'string'
            ? errorMsg
            : Array.isArray(errorMsg)
              ? errorMsg.join(', ')
              : 'Failed to commit manifest',
        );
        this.setState({
          preventAssignmentPopupClick: false,
          commitManifestLoading: false,
        });
      }
    } catch (error) {
      toast.error('Failed to commit manifest');
      console.error('Manifest commit error:', error);
      this.setState({
        preventAssignmentPopupClick: false,
        commitManifestLoading: false,
      });
    }
  };

  closeEmailManifestModal = () => {
    this.setState({
      emailManifestModalOpen: false,
      mailList: [],
      mailSearchKeyword: '',
      hideSearch: 'hide',
      validManifestMail: false,
      manifestEmail: '',
    });
    document.getElementById('txtSearchManiEmployees').value = '';
  };

  handleSendEmailManifest = () => {
    const manifestId = this.state.currentAssignmentDetails?.manifest_id;
    if (!manifestId) {
      return toast.error('Manifest ID not found.');
    }

    let data = new FormData();
    data.append('manifest_id', manifestId);
    data.append('resource_id', this.state.id);
    let toList = this.state.dispatchMailList;

    if (this.state.mailList?.length > 0) {
      toList = [...toList, ...this.state.mailList.map((item) => item.email)];
    }

    data.append('to', toList.join());

    this.props.dispatch(manifestActions.emailManifest(data));
    this.props.details(this.state.id);
    this.closeEmailManifestModal();
    toast.success('Email sent successfully!');
  };

  // Handle Resource Status Update (Available/Unavailable)
  handleResourceStatusUpdate = async () => {
    try {
      this.setState({
        preventAssignmentPopupClick: true,
      });

      // Prepare data for the new API
      const data = {
        resource_identifier_id: this.state.id,
        resource_status: this.state.tempAssignmentStatus.toLowerCase(),
        notes: this.state.notes || '',
      };

      // Validation for Available status
      if (this.state.tempAssignmentStatus === 'Available') {
        if (!this.state.unavailable_end_date) {
          this.setState({ preventAssignmentPopupClick: false });
          return toast.error('Unavailable end date is required.');
        }

        data.end_date = moment(this.state.unavailable_end_date).format(
          'YYYY-MM-DD',
        );
      }

      // Add unavailable-specific fields
      if (this.state.tempAssignmentStatus === 'Unavailable') {
        data.unavailable_reason_id = this.state.unavailable_reason_id;
        data.start_date = moment(this.state.unavailable_start_date).format(
          'YYYY-MM-DD',
        );
        data.end_date = moment(this.state.unavailable_end_date).format(
          'YYYY-MM-DD',
        );
      }
      // Call the new API
      const response = await manifestService.updateResourceStatus(data);

      if (response.status === 'success') {
        this.setState(
          {
            preventAssignmentPopupClick: false,
          },
          () => {
            this.fetchData();
            toast.success('Resource status updated successfully!');
            this.closeStatusPopup();
          },
        );
      } else {
        this.setState({ preventAssignmentPopupClick: false });
        toast.error('Failed to update resource status');
      }
    } catch (error) {
      this.setState({
        preventAssignmentPopupClick: false,
      });
      console.error('Error updating resource status:', error);
      toast.error('Failed to update resource status');
    }
  };

  // Submit Assignment Changes
  saveAssignmentChanges = (event) => {
    event?.preventDefault();

    // Handle manifest close out case (when opened from Manifest Status: In Use)
    if (
      this.state.isManifestCloseOut &&
      this.state.manifestStatus === 'inuse'
    ) {
      if (!this.state.manifestCloseOutDateOff) {
        return toast.error('Date Off is a required field.');
      }
      if (!this.state.manifestCloseOutHotlineShifts) {
        return toast.error('Hotline Shifts is a required field.');
      }

      // Call the new closeManifest API
      const manifestId = this.state.currentAssignmentDetails?.manifest_id;
      if (!manifestId) {
        return toast.error('Manifest ID not found.');
      }

      const data = {
        manifestId: manifestId,
        resourceIdentifierId: this.state.id,
        dateOff: moment(this.state.manifestCloseOutDateOff).format(
          'YYYY-MM-DD',
        ),
        hotlineShifts: parseInt(this.state.manifestCloseOutHotlineShifts),
        notes: this.state.manifestCloseOutNotes || '',
      };

      this.handleCloseManifest(data);
      return;
    }

    // Handle manifest commit case (when opened from Manifest Status: Manifest Pending)
    if (
      this.state.isManifestCloseOut &&
      this.state.manifestStatus === 'pending'
    ) {
      if (!this.refs.AssignmentType?.value) {
        return toast.error('Assignment Type is a required field.');
      }
      if (!this.state.fireHistoryManifestId) {
        return toast.error('Manifest is a required field.');
      }
      if (!this.state.onDate) {
        return toast.error('Date On is a required field.');
      }

      this.handleCommitManifest();
      return;
    }

    if (this.state.editMode && !this.state.confirmEditAssignment) {
      return this.setState({
        displayEditAssignmentConfirmPopup: true,
      });
    }
    if (!this.state.tempAssignmentStatus) {
      return toast.error('Please select an assignment status.');
    }

    // Handle Available and Unavailable status with new API (only when creating new status updates)
    if (
      !this.state.editMode &&
      (this.state.tempAssignmentStatus === 'Available' ||
        this.state.tempAssignmentStatus === 'Unavailable')
    ) {
      this.handleResourceStatusUpdate();
      return;
    }
    if (!this.state.editMode) {
      if (
        this.state.currentAssignmentStatus == 'Committed' &&
        !this.state.hotline_shifts
      ) {
        return toast.error('Hotline Shifts is a required field.');
      }
    }

    this.setState({
      preventAssignmentPopupClick: true,
    });

    let index = this.state.assignmentStatusOptions.findIndex(
      (x) => x == this.state.tempAssignmentStatus,
    );

    let data = new FormData();
    data.append('status', index + 1);
    data.append('resource_identifier_id', this.state.id);
    data.append('location', this.state.location);
    data.append('complexity', this.state.complexity);
    data.append('fuel_type', this.state.fuel_type);
    data.append('fire_size', this.state.fire_size);
    if (this.state.hotline_shifts) {
      data.append('hotline_shifts', this.state.hotline_shifts);
    }

    if (this.state.offDate) {
      data.append('date_off', moment(this.state.offDate).format('YYYY-MM-DD'));
    }

    if (this.state.unavailable_start_date) {
      data.append(
        'unavailable_start_date',
        moment(this.state.unavailable_start_date).format('YYYY-MM-DD'),
      );
    }

    if (this.state.unavailable_end_date) {
      data.append(
        'unavailable_end_date',
        moment(this.state.unavailable_end_date).format('YYYY-MM-DD'),
      );
    }

    if (this.state.editMode == true) {
      data.append('assignment_history_id', this.state.assignmentHistoryId);
    }

    if (this.state.tempAssignmentStatus == 'Committed') {
      if (!this.refs.AssignmentType.value) {
        this.setState({
          preventAssignmentPopupClick: false,
        });
        return toast.error('Assigment Type is a required field');
      }
      if (!this.state.editMode && !this.state?.fireHistoryManifestId) {
        this.setState({
          preventAssignmentPopupClick: false,
        });
        return toast.error('Manifest is a required field');
      }
      data.append('assignment_type', this.refs.AssignmentType.value);

      if (this.state.editMode == true) {
        if (this.refs.ProjectName) {
          data.append('name', this.refs.ProjectName.value);
          data.append(
            'date_on',
            moment(this.state.onDate).format('YYYY-MM-DD'),
          );

          if (this.refs.totalShifts?.value) {
            data.append('shifts', this.refs.totalShifts.value);
          }
        }
        data.append('notes', this.refs.note.value);
      } else if (this.state.editMode == false) {
        data.append('name', this.refs.ProjectName.value);
        data.append('assignment_type', this.refs.AssignmentType.value);
        data.append('date_on', moment(this.state.onDate).format('YYYY-MM-DD'));
        if (this.state.offDate) {
          data.append(
            'date_off',
            moment(this.state.offDate).format('YYYY-MM-DD'),
          );
        }
        if (this.refs.totalShifts?.value) {
          data.append('shifts', this.refs.totalShifts.value);
        }
        data.append('notes', this.refs.note.value);
      }
    }

    this.state.tempAssignmentStatus === 'Unavailable' &&
      data.append('unavailable_reason_id', this.state.unavailable_reason_id);

    if (this.state.tempAssignmentStatus !== 'Committed') {
      data.append('notes', this.refs.note.value);
    }

    // Fire history
    if (this.state.tempAssignmentStatus == 'Committed') {
      data.append('type_slug', this.state?.typeSlug);
      data.append('manifest_id', this.state?.fireHistoryManifestId);
    }

    this.handleSaveStatus(data);
    if (this.refs.note) this.refs.note.value = '';
  };

  showEditRoPopup = (item) => {
    // If resources don't have IDs, use the current resource ID
    const selectedResource = item?.resources?.length
      ? item.resources.map((resource) => ({
        value: resource.id || this.state.id, // Fallback to current resource ID
        label: resource.resource_name,
      }))
      : [
        {
          value: this.state.id, // Default to current resource
          label: this.props.resourceDetails?.resource_name || '',
        },
      ];

    this.setState({
      selectedUploadedROFile: item,
      selectedResource: selectedResource,
      copySelectedResource: selectedResource,
      editROModal: true,
    });
  };

  handleSaveStatus = async (data) => {
    try {
      await this.props.dispatch(assignmentStatsActions.saveStatus(data));

      this.setState(
        {
          preventAssignmentPopupClick: false,
        },
        () => {
          this.fetchData();
          toast.success('Assignment status saved successfully!');
          this.closeStatusPopup();
        },
      );
    } catch (error) {
      this.setState({
        preventAssignmentPopupClick: false,
      });
      const parsedError = JSON.parse(error);
      if (typeof parsedError.message == 'string') {
        toast.error(`Failed to save assignment status: ${parsedError.message}`);
      } else {
        toast.error(`Failed to save assignment status`);
      }
    }
  };

  viewManifest(id, type) {
    this.props.viewManifest(id, type.toString());
  }

  handleChange(e) {
    this.setState({ [e.target.name]: e.target.value });
  }

  goBack() {
    this.props.goBack();
  }

  profile(hash) {
    this.setState({
      linkClick: hash,
    });
  }

  editResource() {
    const resourceId = typeof this.props.props === 'object' 
      ? this.props.props?.id 
      : this.props.props;
    if (resourceId) {
      this.props.editResource(resourceId);
    }
  }

  keyUpFn(event) {
    var value = event.target.value;
    clearTimeout(this.state.timeout);
    this.state.timeout = setTimeout(
      function () {
        this.handleSearch(value, false);
      }.bind(this),
      1000,
    );
  }

  emailChangeFn(event) {
    var value = event.target.value;
    this.setState(
      {
        mailSearchKeyword: value,
        validManifestMail: false,
      },
      () => {
        clearTimeout(this.state.timeout);
        this.state.timeout = setTimeout(
          function () {
            this.handleSearch(value, true);
          }.bind(this),
          1000,
        );
      },
    );
  }

  handleSearch(text, email) {
    let data = new FormData();
    data.append('keyword', text);

    const nextState = {
      search: true,
    };

    if (this.isValidEmail(text)) {
      nextState.validManifestMail = true;
      nextState.manifestEmail = text;
    } else {
      nextState.validManifestMail = false;
      nextState.manifestEmail = '';
    }

    if (!email) {
      data.append('crew_identifier_id', this.state.id);
      data.append('active', true);
      data.append('locked', true);
      data.append('guest', true);
      data.append('pagination', false);
    }

    this.props.dispatch(resourceActions.employeeList(data));
    this.setState(nextState);
  }

  remove() {
    this.statusCloseModal();
    this.props.dispatch(resourceActions.removeResource(this.state.id));
  }

  sendMail(email) {
    // Extract manifest ID from action_id
    const manifestId = this.state.action_id.split('-')[0];

    this.setState(
      { to: email, manifest_id: manifestId, emailSuccess: 'true' },
      function () {
        this.emailManifest();
        this.statusCloseModal();
      },
    );
  }

  setMailer(item) {
    this.setState({
      textarea: false,
      mailList: [...this.state.mailList, item],
      searchList: [],
      hideSearch: 'hide',
    });
  }

  removeList(index) {
    if (index >= 0) {
      let mailList = Object.assign([], this.state.mailList);
      mailList.splice(index, 1);
      this.setState({ mailList: mailList, textarea: true, to: '' });
      document.getElementById('txtSearchManiEmployees').value = '';
    }
  }

  removeDispatchList(index) {
    if (index >= 0) {
      let mailList = Object.assign([], this.state.dispatchMailList);
      mailList.splice(index, 1);
      this.setState({ dispatchMailList: mailList });
      if (document.getElementById('txtSearchManiEmployees')) {
        document.getElementById('txtSearchManiEmployees').value = '';
      }
    }
  }

  componentWillReceiveProps(nextProps) {
    window.addEventListener('scroll', this.handleScroll);
    const { vehicles, assignmentStats, user, inventory, permission } =
      nextProps;

    var vehiclesOption = [];

    if (nextProps.resource) {
      if (nextProps.resource.remove) {
        const remove_status = nextProps.resource.remove;

        if (remove_status.success) {
          this.setState({
            redirect: '/resources',
          });
        } else {
          this.setState({
            alertPop: true,
            alertHead: 'Error',
            alertMsg: nextProps.resource.remove.message,
          });
        }
      }

      if (nextProps.resource.projects) {
        this.setState({
          incidentProjects: nextProps.resource.projects,
        });
      }
    }

    if (nextProps.singleresource.items) {
      if (nextProps.singleresource.items.data) {
        this.setState({
          resource_name: nextProps.singleresource.items.data.resource_name,
        });
      }
    }

    if (vehicles.items) {
      this.setState({ outerVehicle: vehicles.items });
      if (vehicles.items.data?.length > 0) {
        vehicles.items.data.forEach((item, index) => {
          vehiclesOption.push(
            <div className='applicant_item' key={index}>
              <div className='basic_info'>
                <a
                  href={config.baseUrl + 'inventory/inventory-view/' + item.eid}
                  className='vehicleLink'
                >
                  <div className='appln_name'>{item.name}</div>
                  <div className='appln_email'>
                    {item.user
                      ? item.user.first_name + ' ' + item.user.last_name
                      : ''}
                  </div>
                  <div className='appln_phone'>
                    {item.user ? item.user.drivers_license : ''}
                  </div>
                  <div className='appln_date'>{item.vehicle_model_or_make}</div>
                  <div className='appln_area'>
                    {item.vehicle_license === unDefined
                      ? ''
                      : item.vehicle_license}
                  </div>
                </a>
              </div>
            </div>,
          );
        });
      } else {
        vehiclesOption.push(
          <div className='applicant_item' key='noVehicles'>
            <p>No Vehicles added!</p>
          </div>,
        );
      }
      this.setState({ vehiclesOption });
    }

    if (vehicles.vehicleList) {
      this.setState({ vehicleList: vehicles.vehicleList });
    }

    const { manifest, employee, email } = nextProps;

    if (this.state.search && employee?.list) {
      let empOptions = [];
      if (employee.list.data?.data) {
        employee.list.data.data.map((item, index) => {
          empOptions.push(
            <li key={index} onClick={this.setMailer.bind(this, item)}>
              {item.first_name + ' ' + item.last_name}
            </li>,
          );
          return empOptions;
        });
      }

      this.setState({
        searchList: empOptions,
        search: false,
        hideSearch: empOptions.length > 0 ? 'show' : 'hide',
      });
    }

    if (employee.list) {
      if (
        employee.list.data &&
        Array.isArray(employee?.list?.data?.data) &&
        employee?.list?.data?.data?.length > 0
      ) {
        this.setState({
          employeeList: employee.list.data.data,
          resultData: employee.list.data,
          flag: true,
        });
      } else {
        this.setState({ employeeList: [], resultData: [] });
      }
    }
    if (email) {
      if (email.manifestEmail) {
        var head = '';
        if (email.manifestEmail.success) {
          head = 'Success';
        } else {
          head = 'Error';
        }
        if (this.state.emailSuccess === 'true') {
          this.setState({
            alertPop: true,
            alertHead: head,
            alertMsg: JSON.parse(JSON.stringify(email.manifestEmail.message)),
            alertFunction: '',
            emailSuccess: '',
          });
        }
      }
    }
    if (manifest) {
      if (manifest.print) {
      }

      if (manifest.dispatchMailList) {
        this.setState({ dispatchMailList: manifest.dispatchMailList });
      }

      if (manifest.ManifestList) {
        this.setState({ ManifestList: manifest.ManifestList.data });
      }

      if (manifest.ManifestListV1) {
        this.setState({
          ManifestListV1: manifest.ManifestListV1.data.data,
          manifestPagination: manifest.ManifestListV1.data.pagination,
        });
      }

      if (manifest.saved && manifest.saved !== this.props.manifest?.saved) {
        this.props.dispatch(
          assignmentStatsActions.getAssignemntHistory(this.state.id, 1),
        );
      }
    }
    if (assignmentStats.applicantStats) {
      let { assignmentStatusOptions } = this.state;

      let currentAssignmentDetails = {};
      if (assignmentStats.applicantStats.data.summary?.length > 0) {
        currentAssignmentDetails = {
          name: assignmentStats.applicantStats.data.summary[0].name,
          date_off: assignmentStats.applicantStats.data.summary[0].date_off,
          date_on: assignmentStats.applicantStats.data.summary[0].date_on,
          assignment_type_id:
            assignmentStats.applicantStats.data.summary[0].assignment_type_id,
          assignment_type:
            assignmentStats.applicantStats.data.summary[0].assignment_type,
          shifts: assignmentStats.applicantStats.data.summary[0].shifts,
          id: assignmentStats.applicantStats.data.summary[0].id,
          location: assignmentStats.applicantStats.data.summary[0].location,
          complexity: assignmentStats.applicantStats.data.summary[0].complexity,
          fuelType: assignmentStats.applicantStats.data.summary[0].fuel_type,
          fireSize: assignmentStats.applicantStats.data.summary[0].fire_size,
          hotlineShifts:
            assignmentStats.applicantStats.data.summary[0].hotline_shifts,
          manifest_id:
            assignmentStats.applicantStats.data.summary[0].manifest_id,
        };
        if (currentAssignmentDetails?.date_off) {
          const currentDate = new Date();
          this.setState({
            isCrewCommitted:
              new Date(currentAssignmentDetails?.date_off) > currentDate,
          });
        }
      }

      if (assignmentStats.applicantStats.data.notes) {
        currentAssignmentDetails.notes =
          assignmentStats.applicantStats.data.notes;
      }

      // Note: currentAssignmentStatus is now set by fetchResourceDetails() API call
      // which uses the resource_availability_status from the backend
      const manifestStatus =
        assignmentStats.applicantStats.data.manifestStatus ||
        this.state.manifestStatus;

      this.setState({
        currentAssignmentDetails,
        manifestStatus,
      });
    }
    if (assignmentStats.types) {
      this.setState({ assigmentCategoryOptions: assignmentStats.types });
    }
    if (assignmentStats.assignmentHistory) {
      this.setState({
        assigmentStatusHistory: assignmentStats.assignmentHistory.data,
        latestAssignmentHistory:
          assignmentStats.assignmentHistory.additional_data
            ?.latestAssignmentHistory,
      });
    }

    if (assignmentStats.assignmentStatusSaved) {
      if (assignmentStats.assignmentStatusSaved.success) {
        this.props.dispatch(
          assignmentStatsActions.getAssignemntStatus(this.state.id),
        );
        this.employeeListUpdated();
        this.props.dispatch(
          assignmentStatsActions.getAssignemntHistory(this.state.id, 1),
        );
        this.setState({
          tempAssignmentStatus: {
            name: '',
            date_off: '',
            date_on: '',
            assignment_type_id: '',
            assignment_type: '',
            shifts: '',
            notes: '',
            id: 0,
          },
        });
      } else {
        var message = assignmentStats.assignmentStatusSaved.message || {},
          err = [];
        if (Object.keys(message).length) {
          for (var key in message) {
            var ele = message[key];
            var _err = err.push(Array.isArray(ele) ? ele.join(',') : ele);
          }
        }

        if (err.length) {
          this.setState({
            errorMessage: err.join(','),
          });
          setTimeout(() => {
            this.setState({
              errorMessage: '',
            });
            this.props.dispatch(assignmentStatsActions.resetStatus());
          }, 3000);
        }
      }
    }
    if (assignmentStats.historyDelete) {
      this.props.dispatch(
        assignmentStatsActions.getAssignemntStatus(this.state.id),
      );
      this.props.dispatch(
        assignmentStatsActions.getAssignemntHistory(this.state.id, 1),
      );
      // Refresh deleted history list after successful delete
      this.fetchDeletedManifestHistory(this.state.deletedHistoryPage);

      // Call get-resource-details API
      this.setState({ resourceDetailsLoading: true });
      manifestService
        .getResourceDetails(this.state.id)
        .then((response) => {
          if (response.status === 'success') {
            const resourceData = response.data;

            // Update state with resource availability status
            let currentAssignmentStatus = 'Available'; // Default status

            switch (resourceData.resource_availability_status) {
              case 'available':
                currentAssignmentStatus = 'Available';
                break;
              case 'unavailable':
                currentAssignmentStatus = 'Unavailable';
                break;
              case 'committed':
                currentAssignmentStatus = 'Committed';
                break;
              default:
                currentAssignmentStatus = 'Available';
            }

            this.setState({
              currentAssignmentStatus,
              resourceAvailabilityStatus:
                resourceData.resource_availability_status,
              unavailabilityDetails: resourceData.unavailability_details,
              resourceDetailsLoading: false,
            });
          } else {
            this.setState({ resourceDetailsLoading: false });
          }
        })
        .catch((error) => {
          console.error('Error fetching resource details:', error);
          this.setState({ resourceDetailsLoading: false });
        });

      // Call get manifest list API
      this.getManifestList();
    }

    if (inventory.list?.length) {
      this.setState({
        inventoryList: inventory.list,
      });
    }
  }
  getHistoryList = (pageNum) => {
    this.props.dispatch(
      assignmentStatsActions.getAssignemntHistory(this.state.id, pageNum),
    );
  };

  handleChooseResources = async (text) => {
    let data = new FormData();
    data.append('keyword', text);
    const response = await this.props.dispatch(
      resourceActions.searchResource(data),
    );
    let resourceList = [];
    const items = response.data;
    var res = [];
    for (var key in items) {
      var arr = items[key];
      if (arr.length) {
        res = res.concat(arr);
      }
    }
    if (res.length > 0) {
      res.forEach((item) => {
        let resource = {
          label: item.resource_name,
          value: item.id,
        };
        resourceList.push(resource);
      });
    }
    return resourceList;
  };

  handleViewResourceOrderForm(manifest) {
    try {
      const resourceOrderFormType =
        manifest.resourceOrderFormType || manifest.resource_order_form_type;
      const resourceOrderForm =
        manifest.resourceOrderForm || manifest.resource_order_form;

      switch (resourceOrderFormType) {
        case RESOURCE_ORDER_FILE_TYPE?.UPLOADED_FORM:
          if (resourceOrderForm) {
            window.open(resourceOrderForm, '_blank').focus();
          } else {
            toast.error('Resource order form file not found');
          }
          break;
        case RESOURCE_ORDER_FILE_TYPE?.CREATE_FORM:
          this.printResourceOrderForm(manifest);
          break;
        default:
          // Try to handle as UPLOADED_FORM if resourceOrderForm exists
          if (resourceOrderForm) {
            window.open(resourceOrderForm, '_blank').focus();
          } else {
            console.warn(
              'Unknown resource order form type:',
              resourceOrderFormType,
            );
            toast.error('Unable to view resource order form');
          }
          break;
      }
    } catch (error) {
      console.error('Error viewing resource order form:', error);
      toast.error('Error viewing resource order form');
    }
  }

  printResourceOrderForm(manifest) {
    try {
      let data = new FormData();
      const manifestId =
        manifest.manifestId || manifest.manifest_id || manifest.mid;
      data.append('manifest_id', manifestId);

      manifestService
        ?.viewCreatedResourceOrderForm(data)
        .then((response) => {
          this?.redirectToPdf(response);
        })
        .catch((error) => {
          console.error('Error fetching resource order form:', error);
          toast.error('Error loading resource order form');
        });
    } catch (error) {
      console.error('Error in printResourceOrderForm:', error);
      toast.error('Error generating resource order form');
    }
  }

  unassignOldManifest(manifestId, index) {
    manifestService?.unassignManifest(manifestId).then((response) => {
      // Show success message
      toast.success(
        'Manifest has been unassigned successfully. You can now assign this manifest to the crew.',
      );

      // Update assignment_status to 1 for the unassigned item
      this.setState((prevState) => {
        const updatedManifestList = [...prevState.ManifestList.data];
        updatedManifestList[index].assignment_status = 1;

        return {
          ManifestList: {
            ...prevState.ManifestList,
            data: updatedManifestList,
          },
        };
      });
    });
  }

  redirectToPdf(data) {
    if (data?.success) {
      const pdfLink = data.data;
      var link = document.createElement('a');
      if (
        window.navigator.userAgent.match(/iPad/i) ||
        window.navigator.userAgent.match(/iPhone/i)
      ) {
        link.href = pdfLink;
      } else {
        link.href = pdfLink;
        link.target = '_blank';
      }
      document.body.appendChild(link);
      link.click();
      setTimeout(function () {
        document.body.removeChild(link);
        // For Firefox it is necessary to delay revoking the ObjectURL
        window.URL.revokeObjectURL(pdfLink);
      }, 100);
    }
  }

  deleteHistory = () => {
    if (this.state.historyId == '') {
      return;
    }
    this.setState({ deleteHistoryOpen: false });
    this.props.dispatch(
      assignmentStatsActions.historyDelete(this.state.historyId),
    );
  };

  /**
   * function to open slider to edit the assignment status
   */
  editStatus = () => {
    let offDate = null;
    let unavailable_end_date = null;
    if (this.state.latestAssignmentHistory) {
      if (
        this.state.latestAssignmentHistory.incident_projects?.date_on &&
        this.state.currentAssignmentStatus == 'Committed'
      ) {
        offDate =
          currentDate >=
            this.state.latestAssignmentHistory.incident_projects?.date_on
            ? currentDate
            : this.state.latestAssignmentHistory.incident_projects?.date_on;
      } else if (
        this.state.latestAssignmentHistory.resource_unavailability
          ?.start_date &&
        this.state.currentAssignmentStatus == 'Unavailable'
      ) {
        unavailable_end_date =
          currentDate >=
            this.state.latestAssignmentHistory.resource_unavailability?.start_date
            ? currentDate
            : this.state.latestAssignmentHistory.resource_unavailability
              ?.start_date;
      }
    }

    this.setState({
      editMode: false,
      preventAssignmentPopupClick: false,
      tempAssignmentStatus: '',
      tempAssignmentType: '',
      projectId: null,
      projectName: '',
      projectShift: '',
      initialStatusId: null,
      onDate: moment(currentDate),
      offDate: null,
      unavailable_end_date: unavailable_end_date
        ? moment(unavailable_end_date)
        : null,
      projectNote: '',
      location: '',
      complexity: '',
      fuel_type: '',
      fire_size: '',
      hotline_shifts: '',
      // Initialize manifest close out fields
      manifestCloseOutDateOff: null,
      manifestCloseOutHotlineShifts: '',
      manifestCloseOutNotes: '',
      isManifestCloseOut: false, // Regular assignment status change
    });

    document.body.className += ' ' + 'inv-sidebar-opened';
  };

  editManifestStatus = () => {
    // Initialize based on manifest status
    const isPending = this.state.manifestStatus === 'pending';
    const { currentAssignmentDetails } = this.state;

    // Determine onDate: use date_on if pending and available, otherwise use currentDate
    const onDate =
      isPending && currentAssignmentDetails.date_on
        ? moment(currentAssignmentDetails.date_on)
        : moment(currentDate);

    // Determine offDate: use date_off if pending and available, otherwise null
    const offDate =
      isPending && currentAssignmentDetails.date_off
        ? moment(currentAssignmentDetails.date_off)
        : null;

    this.setState({
      editMode: false,
      preventAssignmentPopupClick: false,
      tempAssignmentStatus: '',
      tempAssignmentType: '',
      projectId: null,
      projectName: currentAssignmentDetails.name || '',
      projectShift: '',
      initialStatusId: null,
      onDate,
      offDate,
      unavailable_end_date: null,
      projectNote: this.state.currentAssignmentDetails.notes || '',
      location: this.state.currentAssignmentDetails.location || '',
      complexity: this.state.currentAssignmentDetails.complexity || '',
      fuel_type: this.state.currentAssignmentDetails.fuelType || '',
      fire_size: this.state.currentAssignmentDetails.fireSize || '',
      hotline_shifts: '',
      // Initialize manifest close out fields (for inuse)
      manifestCloseOutDateOff: null,
      manifestCloseOutHotlineShifts: '',
      manifestCloseOutNotes: '',
      isManifestCloseOut: true, // Manifest close out/commit mode
      fireHistoryManifestId:
        this.state.currentAssignmentDetails.manifest_id || null,
    });

    document.body.className += ' ' + 'inv-sidebar-opened';
  };

  handleAssignmentChange = (event) => {
    this.setState({
      tempAssignmentStatus: event.target.value,
      unavailable_start_date:
        event.target.value == 'Unavailable' ? moment(currentDate) : null,
      unavailable_end_date:
        event.target.value == 'Available' &&
          this.state.unavailabilityDetails?.end_date
          ? moment(this.state.unavailabilityDetails.end_date)
          : event.target.value == 'Unavailable'
            ? null
            : this.state.unavailable_end_date,
    });
  };

  handleFireHistoryAssignModal = () => {
    switch (this.state?.typeSlug) {
      case FIRE_HISTORY_TYPE_SLUG?.AUTO_ASSIGN_MANIFEST:
        this.saveAssignmentChanges();
        this.setState({ enableAssignEmployeeModal: false });
        break;
      case FIRE_HISTORY_TYPE_SLUG?.MANUAL_ASSIGN_MANIFEST:
        this?.sortYourCrewRef?.current?.toVehicle((res) => {
          if (res?.length) {
            this.setState(
              {
                manualAssignManifestIds: res?.map((item) => item?.userid),
                enableAssignEmployeeModal: false,
              },
              () => {
                this.saveAssignmentChanges();
              },
            );
          }
        });
        break;
    }
  };

  handleAutoAssignModalClose() {
    this.setState({ enableAssignEmployeeModal: false, typeSlug: null });
  }

  render() {
    if (this.state.linkClick !== false)
      return <Redirect to={this.state.linkClick} />;
    let crew_data = null;
    this.props.assignmentStats?.applicantStats &&
      (crew_data = this.props.assignmentStats.applicantStats.data);
    const { pageNumber } = this.state;
    const { permission } = this.props;

    const { persist } = this.props.assignmentStats || {};
    const { complexity, fuelType, fireSize } = persist || {};

    var manifestsOption = [];
    var permList = [];
    let pages = [];
    let paginationHtml = [];
    let paginationHistoryHtml = [];
    if (permission?.permissions?.data) {
      permList = Array.isArray(permission.permissions.data) 
        ? permission.permissions.data 
        : [];
    }
    if (this.state.redirect === '/resources') {
      return <Redirect to='/resources' />;
    }

    let { inventoryList, inventoryPerPage, inventoryPage } = this.state;

    if (this.state.assigmentStatusHistory.data?.length > 0) {
      let pages = [];
      let currentPage = this.state.assigmentStatusHistory.current_page;
      let startingIndex = currentPage - 2 > 0 ? currentPage - 2 : 1;
      let lastPageIndex =
        currentPage + 2 < this.state.assigmentStatusHistory.last_page
          ? currentPage + 2
          : this.state.assigmentStatusHistory.last_page;
      let nextPage =
        currentPage + 1 > this.state.assigmentStatusHistory.last_page
          ? this.state.assigmentStatusHistory.last_page
          : currentPage + 1;
      let prevPage = currentPage - 1 > 0 ? currentPage - 1 : 1;
      if (currentPage > 3) {
        pages.push(
          <li
            className='inactive'
            key={0}
            onClick={() => {
              this.getHistoryList(1);
            }}
          >
            <a>1</a>
          </li>,
        );
      }
      if (currentPage > 4) {
        pages.push(
          <li className='inactive' key={1}>
            <a>. . .</a>
          </li>,
        );
      }
      for (let i = startingIndex; i <= lastPageIndex; i++) {
        // getManifestList
        pages.push(
          <li
            className={i == currentPage ? 'active' : 'inactive'}
            key={i}
            onClick={() => {
              this.getHistoryList(i);
            }}
          >
            <a>{i}</a>
          </li>,
        );
      }
      if (
        lastPageIndex + 1 <
        this.state.assigmentStatusHistory.data.last_page
      ) {
        pages.push(
          <li
            className='inactive'
            key={this.state.assigmentStatusHistory.data.last_page + 1}
          >
            <a>. . .</a>
          </li>,
        );
      }
      if (lastPageIndex < this.state.assigmentStatusHistory.data.last_page) {
        pages.push(
          <li
            className='inactive'
            key={this.state.assigmentStatusHistory.data.last_page}
            onClick={() => {
              this.getHistoryList(
                this.state.assigmentStatusHistory.data.last_page,
              );
            }}
          >
            <a>{this.state.assigmentStatusHistory.data.last_page}</a>
          </li>,
        );
      }

      if (pages?.length > 0) {
        paginationHistoryHtml.push(
          <div
            className='fs-pagination-wrapper-outer custome_old_pagination'
            key={7}
          >
            <div className='fs-pagination-wrapper'>
              <span
                className={`prev ${prevPage === 1 && currentPage === 1 ? 'disabled' : ''
                  }`}
                onClick={() => {
                  this.getHistoryList(prevPage);
                }}
              >
                <img
                  alt='previous'
                  src={require('../assets/icons/next_arrow.svg').default}
                />
              </span>
              <ul className='fs-pagination'>{pages}</ul>
              <span
                className={`next ${nextPage == this.state.assigmentStatusHistory.last_page
                    ? 'disabled'
                    : ''
                  }`}
                onClick={() => {
                  this.getHistoryList(nextPage);
                }}
              >
                <img
                  alt='previous'
                  src={require('../assets/icons/next_arrow.svg').default}
                />
              </span>
            </div>
          </div>,
        );
      }
    }

    // Use V1 API pagination data if available, otherwise fall back to old data
    const paginationData =
      this.state.manifestPagination || this.state.ManifestList;

    if (paginationData) {
      if (
        this.state.ManifestListV1?.length > 0 ||
        paginationData.data?.length > 0
      ) {
        let currentPage = paginationData.current_page;
        let startingIndex = currentPage - 2 > 0 ? currentPage - 2 : 1;
        let lastPageIndex =
          currentPage + 2 < paginationData.last_page
            ? currentPage + 2
            : paginationData.last_page;
        let nextPage =
          currentPage + 1 > paginationData.last_page
            ? paginationData.last_page
            : currentPage + 1;
        let prevPage = currentPage - 1 > 0 ? currentPage - 1 : 1;
        //
        if (currentPage > 3) {
          pages.push(
            <li
              className='inactive'
              key={0}
              onClick={() => {
                this.getManifestList(1);
              }}
            >
              <a>1</a>
            </li>,
          );
        }
        if (currentPage > 4) {
          pages.push(
            <li className='inactive' key={paginationData.last_page + 1}>
              <a>. . .</a>
            </li>,
          );
        }
        for (let i = startingIndex; i <= lastPageIndex; i++) {
          // getManifestList
          pages.push(
            <li
              className={i == currentPage ? 'active' : 'inactive'}
              key={i}
              onClick={() => {
                this.getManifestList(i);
              }}
            >
              <a>{i}</a>
            </li>,
          );
        }
        if (lastPageIndex + 1 < paginationData.last_page) {
          pages.push(
            <li className='inactive' key={paginationData.last_page + 1}>
              <a>. . .</a>
            </li>,
          );
        }
        if (lastPageIndex < paginationData.last_page) {
          pages.push(
            <li
              className='inactive'
              key={paginationData.last_page}
              onClick={() => {
                this.getManifestList(paginationData.last_page);
              }}
            >
              <a>{paginationData.last_page}</a>
            </li>,
          );
        }
        if (pages?.length > 0) {
          paginationHtml.push(
            <div
              className='fs-pagination-wrapper-outer custome_old_pagination'
              key={7}
            >
              <div className='fs-pagination-wrapper'>
                <span
                  className={`prev ${prevPage === 1 && currentPage === 1 ? 'disabled' : ''
                    }`}
                  onClick={() => {
                    this.getManifestList(prevPage);
                  }}
                >
                  <img
                    alt='previous'
                    src={require('../assets/icons/next_arrow.svg').default}
                  />
                </span>
                <ul className='fs-pagination'>{pages}</ul>
                <span
                  className={`next ${nextPage == paginationData.last_page ? 'disabled' : ''
                    }`}
                  onClick={() => {
                    this.getManifestList(nextPage);
                  }}
                >
                  <img
                    alt='previous'
                    src={require('../assets/icons/next_arrow.svg').default}
                  />
                </span>
              </div>
            </div>,
          );
        }
        // Use V1 API data if available, otherwise fall back to old data
        const manifestData =
          this.state.ManifestListV1 || this.state.ManifestList;

        if (manifestData) {
          const manifests = manifestData;

          if (manifests && manifests.length > 0) {
            // Wrap all rows in a single manifest_items container
            const allRows = [];

            manifests.forEach((item, manifestIndex) => {
              // Transform each manifest item
              const manifest = {
                manifestId: item.manifest_id || item.mid,
                abbreviation: item.abbreviation || '',
                contractNumber: item.contract_number || '-',
                incidentName: item.incident_name || '',
                resourceNumber: item.resource_number || '',
                addedDate: item.added_date || '',
                dateAssigned: item.date_assigned || '',
                resourceOrderFormExists: item.resource_order_form_exists,
                resourceOrderName: item.resource_order_name,
                assignmentStatus: item.assignment_status,
                manifestAvailability: item.manifest_availability,
                manifestStatus: item.manifest_status,
                baseManifestId: item.bid || item.base_manifest_id,
                hasLatestVersion: item.has_latest_version,
                resourceOrderFormType: item.resource_order_form_type,
                resourceOrderForm: item.resource_order_form,
                versions: item.versions || [],
              };

              // Determine if there are multiple versions
              const hasMultipleVersions = manifest.versions.length > 1;

              // Render each manifest record independently
              allRows.push(
                <React.Fragment key={`${manifest.manifestId}-${manifestIndex}`}>
                  <CustomToolTip
                    label={this.getStatusLabel(manifest.manifestAvailability)}
                    customClass={'fs-tooltip'}
                  >
                    <div
                      className={`employee_item manifest-row manifest-status-${this.getStatusClass(
                        manifest.manifestAvailability,
                      )}`}
                    >
                      <div className='list_item'>{manifest.abbreviation}</div>
                      <div className='list_item'>{manifest.contractNumber}</div>
                      <div className='list_item'>
                        <div className='incident_name_wrapper'>
                          <div className='incident_name'>
                            {manifest.incidentName}
                          </div>
                        </div>
                      </div>
                      <div className='list_item'>{manifest.resourceNumber}</div>
                      <div className='list_item'>
                        {manifest.resourceOrderFormExists === 1 &&
                          manifest.resourceOrderName ? (
                          <a
                            className=''
                            style={{ cursor: 'pointer' }}
                            onClick={(e) => {
                              e.preventDefault();
                              this.handleViewResourceOrderForm(manifest);
                            }}
                          >
                            View RO
                          </a>
                        ) : (
                          '-'
                        )}
                      </div>
                      <div className='list_item'>
                        {formatDate(manifest.addedDate)}
                      </div>
                      <div className='list_item'>
                        {manifest.dateAssigned
                          ? formatDate(manifest.dateAssigned)
                          : '-'}
                      </div>
                      <div className='list_item manifest-history-column'>
                        {hasMultipleVersions && (
                          <img
                            src={
                              require('../assets/icons/history_24dp.svg')
                                .default
                            }
                            alt='View manifest'
                            className='manifest-history-icon'
                            onClick={() => {
                              this.viewManifest(
                                manifest.manifestId,
                                manifest.baseManifestId,
                              );
                            }}
                          />
                        )}
                      </div>
                      <div
                        className='list_item action_icon'
                        onClick={this.viewAction.bind(
                          this,
                          `${manifest.manifestId}-${manifestIndex}`,
                        )}
                      ></div>
                    </div>
                  </CustomToolTip>
                  {this.state.action_id ===
                    `${manifest.manifestId}-${manifestIndex}` && (
                      <div
                        className={
                          this.state.viewStatus
                            ? 'action_list'
                            : 'action_list hide'
                        }
                      >
                        {permList.includes('Manage Manifests') && (
                          <>
                            {isManifestEditable(
                              manifest.manifestStatus,
                              this.state.resourceAvailabilityStatus,
                            ) && (
                                <p
                                  onClick={this.editManifest.bind(
                                    this,
                                    manifest.manifestId,
                                    manifest.baseManifestId,
                                  )}
                                >
                                  Edit
                                </p>
                              )}
                            {this.state.resourceAvailabilityStatus ===
                              'available' && (
                                <p
                                  onClick={this.duplicateManifest.bind(
                                    this,
                                    manifest,
                                  )}
                                >
                                  Duplicate
                                </p>
                              )}
                            <p
                              onClick={this.printManifest.bind(
                                this,
                                manifest.manifestId,
                              )}
                            >
                              Print
                            </p>
                            <p
                              onClick={this.deleteOpenModal.bind(
                                this,
                                manifest.manifestId,
                              )}
                            >
                              Delete
                            </p>
                          </>
                        )}
                        <p
                          onClick={this.viewManifest.bind(
                            this,
                            manifest.manifestId,
                            manifest.baseManifestId,
                          )}
                        >
                          View
                        </p>
                        {permList.includes('Manage Manifests') && (
                          <p
                            onClick={this.emailOpenModal.bind(
                              this,
                              manifest.manifestId,
                            )}
                          >
                            Email
                          </p>
                        )}
                        {permList.includes('Manage Employees') && (
                          <p
                            onClick={this.printFireCards.bind(
                              this,
                              manifest.manifestId,
                            )}
                          >
                            Print Fire Cards
                          </p>
                        )}
                        {permList.includes('Manage Employees') && (
                          <p onClick={this.emailFireCardsOpenModal.bind(this)}>
                            Email Fire Cards
                          </p>
                        )}
                        {manifest.assignmentStatus == 2 && (
                          <p
                            title='Unassign Old Manifest'
                            onClick={this.unassignOldManifest.bind(
                              this,
                              manifest.manifestId,
                              manifestIndex,
                            )}
                          >
                            Unassign
                          </p>
                        )}
                      </div>
                    )}
                </React.Fragment>,
              );
            });

            // Push toast notification and all rows wrapped in a single manifest_items container
            if (allRows.length > 0) {
              manifestsOption.push(
                <React.Fragment key='all-manifests-wrapper'>
                  <div className='manifest_items'>{allRows}</div>
                </React.Fragment>,
              );
            }
          } else {
            manifestsOption.push(
              <div className='applicant_item' key='noEmployees'>
                <p>No active or used Manifest added!</p>
              </div>,
            );
          }
        }
      } else {
        manifestsOption.push(
          <div className='applicant_item' key='noEmployees'>
            <p>No Manifest added!</p>
          </div>,
        );
      }
    }

    var obj = {
      url:
        config.apiUrl +
        '/api/manifest/pdf?manifest_id=' +
        this.state.mid +
        '&resource_id=' +
        this.state.id,
      httpHeaders: authHeader(),
    };

    const availableEmployees = this.state.employeeList?.filter(
      (employee) => !employee.is_locked && !employee.is_guest,
    );
    const pendingEmployees = this.state.employeeList?.filter(
      (employee) => employee.is_guest,
    );
    const lockedEmployees = this.state.employeeList?.filter(
      (employee) => employee.is_locked && !employee.is_guest,
    );

    // if(employee.list) {
    //     if(employee.list.data.data.length > 0){
    return (
      <div className='resource_container resource_details fs-resource_details resource-details-page'>
        {this.state.resourceDetailsLoading && (
          <div className='resource-details-loader-overlay'>
            <img
              alt='Loader'
              src={require('../assets/images/loader.gif').default}
            />
          </div>
        )}
        <div className='breadcrumbs'>
          <Link className='green' to={'/resources'}>
            Resources
          </Link>{' '}
          / Details
        </div>
        <div className='page_title float'>
          <h1>
            {this.state.resource_name ||
              this.props.props?.resource_name ||
              ''}
          </h1>
          <div className='milage__btn-wraper'>
            {Array.isArray(permList) && permList.includes('Manage Manifests') && (
              <CustomToolTip
                label={this.getCreateManifestTooltip() || ''}
                customClass={'fs-tooltip'}
              >
                <button
                  className='print_button'
                  onClick={this.createManifest?.bind(this) || (() => {})}
                  style={{ marginLeft: 0 }}
                  disabled={!!this.isCreateManifestDisabled()}
                >
                  Create Manifest
                </button>
              </CustomToolTip>
            )}
            {permList.includes('Add/Edit Resource') &&
              (typeof this.props.props === 'object' 
                ? this.props.props?.id !== 1 
                : this.props.props !== 1) && (
                <button
                  className='print_button'
                  onClick={this.editResource.bind(this)}
                >
                  Edit Resource
                </button>
              )}
            {permList.includes('Archive Resource') &&
              (typeof this.props.props === 'object' 
                ? this.props.props?.id !== 1 
                : this.props.props !== 1) && (
                <button
                  className='print_button'
                  onClick={this.statusOpenModal.bind(this)}
                >
                  Archive Resource
                </button>
              )}
            {permList.includes('Manage Employees') && (
              <DropdownBtn
                setPrintOption={this.handlePrintOption}
                label={'Fire Cards'}
                options={[
                  { label: 'Email', value: 'email' },
                  {
                    label: 'Print',
                    value: 'pdf',
                  },
                ]}
              />
            )}
          </div>
        </div>

        <div className='applicants_inner_head crew_outer'>
          <div className='inner_head'>
            <input
              type='text'
              name='keyword'
              className='resource_search'
              placeholder='Search Employees...'
              onKeyUp={this.keyUpFn.bind(this)}
              autoComplete='off'
            />
          </div>
          <div
            className='inner_container col-lg-12 crew_wrapper'
            id='applicants_inner'
          >
            <React.Fragment>
              <div className='assignment-status'>
                {this.state.errorMessage != '' && (
                  <div
                    className='message-display-div alert alert-danger'
                    role='alert'
                  >
                    {this.state.errorMessage}
                  </div>
                )}

                <h5>Assignment Status</h5>
                <div className='status-wrapper'>
                  <div className='row'>
                    <div className='col-sm-4'>
                      <div className='status-left-box'>
                        <div className='current-status'>
                          <h5>Current Status</h5>
                          {this.state.resourceAvailabilityStatus ==
                            'committed' && (
                              <div className='committed'>
                                <span className='status-image'>
                                  <img
                                    src={
                                      require('../assets/images/committed.svg')
                                        .default
                                    }
                                  />
                                </span>
                                {this.state.currentAssignmentStatus}
                              </div>
                            )}
                          {this.state.resourceAvailabilityStatus ==
                            'available' && (
                              <div className='available'>
                                <span className='status-image'>
                                  <img
                                    src={
                                      require('../assets/images/tick.svg').default
                                    }
                                  />
                                </span>
                                {this.state.currentAssignmentStatus}
                              </div>
                            )}
                          {this.state.resourceAvailabilityStatus ==
                            'unavailable' && (
                              <div className='unavailable'>
                                <span className='status-image'>
                                  <img
                                    src={
                                      require('../assets/images/unavailable.svg')
                                        .default
                                    }
                                  />
                                </span>
                                {this.state.currentAssignmentStatus}
                              </div>
                            )}
                          {permList.includes('Status Change Resource') &&
                            this.state.resourceAvailabilityStatus !==
                            'committed' && (
                              <span
                                className='editor'
                                onClick={this.editStatus}
                              >
                                <img
                                  src={
                                    require('../assets/images/edit.svg').default
                                  }
                                />
                              </span>
                            )}
                          {this.state.resourceAvailabilityStatus ==
                            'unavailable' &&
                            this.state.unavailabilityDetails?.end_date !==
                            null && (
                              <div
                                className='unavailability-message'
                                style={{
                                  marginTop: '10px',
                                  fontSize: '14px',
                                  color: '#666',
                                }}
                              >
                                The crew will remain Unavailable until{' '}
                                {this.state.unavailabilityDetails?.date_off
                                  ? formatDate(
                                    this.state.unavailabilityDetails
                                      ?.date_off,
                                  )
                                  : '-'}
                              </div>
                            )}
                        </div>
                      </div>
                    </div>

                    <div className='col-sm-8'>
                      <div className='summary-box'>
                        <h5>Summary</h5>
                        {(this.state.currentAssignmentStatus == 'Committed' ||
                          this.state.manifestStatus === 'pending') && (
                            <div style={{ marginBottom: 10 }}>
                              <div className='lists-outer-row'>
                                <div className='shifts'>
                                  <strong>Manifest Status:</strong>{' '}
                                  {this.getManifestStatusLabel(
                                    this.state.manifestStatus,
                                  )}
                                  {(this.state.manifestStatus === 'inuse' ||
                                    this.state.manifestStatus === 'pending') &&
                                    permList.includes(
                                      'Status Change Resource',
                                    ) && (
                                      <span
                                        className='editor'
                                        title='Close Out'
                                        onClick={this.editManifestStatus}
                                      >
                                        <img
                                          src={
                                            require('../assets/images/edit.svg')
                                              .default
                                          }
                                        />
                                      </span>
                                    )}
                                </div>
                              </div>
                            </div>
                          )}
                        {(this.state.currentAssignmentStatus == 'Committed' ||
                          this.state.manifestStatus === 'pending') && (
                            <React.Fragment>
                              <p className='shifts'>
                                <strong>Incident Name:</strong>{' '}
                                {this.state.currentAssignmentDetails.name}
                              </p>

                              <div className='lists-outer-row'>
                                <div className='shifts'>
                                  <strong>Total Shifts:</strong>{' '}
                                  {this.state.currentAssignmentDetails.shifts}
                                </div>
                                <div className='shifts'>
                                  <strong>Location:</strong>{' '}
                                  {this.state.currentAssignmentDetails.location}
                                </div>
                                <div className='shifts'>
                                  <strong>Complexity:</strong>{' '}
                                  {this.state.currentAssignmentDetails.complexity}
                                </div>
                                <div className='shifts'>
                                  <strong>Fuel Type:</strong>{' '}
                                  {this.state.currentAssignmentDetails.fuelType}
                                </div>
                                <div className='shifts'>
                                  <strong>Fire Size:</strong>{' '}
                                  {this.state.currentAssignmentDetails.fireSize}
                                </div>
                                <div className='shifts'>
                                  <strong>Hotline Shifts:</strong>{' '}
                                  {
                                    this.state.currentAssignmentDetails
                                      .hotlineShifts
                                  }
                                </div>
                                <div className='shifts'>
                                  <strong>Choose Type of Assignment:</strong>{' '}
                                  {
                                    this.state.currentAssignmentDetails
                                      .assignment_type
                                  }{' '}
                                </div>
                                <div className='shifts'>
                                  <strong>Date On:</strong>{' '}
                                  {formatDate(
                                    this.state.currentAssignmentDetails.date_on,
                                  )}
                                </div>
                                <div className='shifts'>
                                  <strong>Date Off:</strong>{' '}
                                  {formatDate(
                                    this.state.currentAssignmentDetails.date_off,
                                  )}
                                </div>
                              </div>
                            </React.Fragment>
                          )}
                        {this.state.currentAssignmentStatus == 'Unavailable' &&
                          crew_data && (
                            <React.Fragment>
                              <p className='shifts'>
                                <strong>Unavailable Reason:</strong>{' '}
                                {crew_data.unavailable_reason}
                              </p>
                            </React.Fragment>
                          )}
                        <p className='shifts'>
                          <strong>Notes:</strong>{' '}
                          {this.state.currentAssignmentDetails.notes}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className='inv-sidemenu-box'>
                <div className='change-stat-head'>
                  <h5>
                    {this.state.editMode
                      ? 'Edit Assignment History'
                      : 'Change Status'}
                  </h5>
                </div>
                <div
                  className={`change-status-pop ${this.state.preventAssignmentPopupClick ? 'disabled' : ''
                    }`}
                >
                  <form
                    onSubmit={this.saveAssignmentChanges}
                    id='assignment-status-form'
                  >
                    {/* Manifest Status In Use - Close Out */}
                    {this.state.manifestStatus === 'inuse' &&
                      this.state.isManifestCloseOut && (
                        <React.Fragment>
                          <div className='form-group'>
                            <label htmlFor='manifestCloseOutStatus'>
                              Select Status *
                            </label>
                            <select
                              className='form-control'
                              id='manifestCloseOutStatus'
                              value='Closed Out'
                              disabled
                              required
                            >
                              <option value='Closed Out'>Closed Out</option>
                            </select>
                          </div>

                          <div className='form-group'>
                            <label htmlFor='manifestCloseOutDateOff'>
                              Date Off *
                            </label>
                            <span className='date-outer'>
                              <span
                                onClick={() => {
                                  this.refs.manifestCloseOutDateOff.setFocus();
                                }}
                                className='datepicker-image'
                              >
                                <img
                                  src={
                                    require('../assets/images/icon_calendar.svg')
                                      .default
                                  }
                                />
                              </span>
                              <DatePicker
                                className='txt'
                                ref='manifestCloseOutDateOff'
                                id='manifestCloseOutDateOff'
                                name='manifestCloseOutDateOff'
                                selected={this.state.manifestCloseOutDateOff}
                                onChange={(date) =>
                                  this.setState({
                                    manifestCloseOutDateOff: date,
                                  })
                                }
                                minDate={
                                  this.state.latestAssignmentHistory &&
                                    this.state.latestAssignmentHistory
                                      .incident_projects?.date_on
                                    ? moment(
                                      this.state.latestAssignmentHistory
                                        .incident_projects.date_on,
                                    )
                                    : null
                                }
                                maxDate={moment()}
                                showMonthDropdown
                                showYearDropdown
                                dropdownMode='select'
                                placeholderText='Select Date'
                                required
                                onKeyDown={(e) => e.preventDefault()}
                              />
                            </span>
                          </div>

                          <div className='form-group name-list-wrapper'>
                            <label htmlFor='manifestCloseOutHotlineShifts'>
                              Hotline Shifts *
                            </label>
                            <input
                              ref='manifestCloseOutHotlineShifts'
                              name='manifestCloseOutHotlineShifts'
                              value={this.state.manifestCloseOutHotlineShifts}
                              onChange={this.handleChange}
                              className='form-control'
                              required
                              type='number'
                              min={0}
                              onWheel={this.handleOnWheel}
                              onKeyDown={preventNegativeValueInDocs}
                            />
                          </div>

                          <div className='form-group'>
                            <label htmlFor='manifestCloseOutNotes'>Notes</label>
                            <textarea
                              ref='manifestCloseOutNotes'
                              name='manifestCloseOutNotes'
                              value={this.state.manifestCloseOutNotes}
                              onChange={this.handleChange}
                              className='form-control'
                              rows='3'
                            ></textarea>
                          </div>
                        </React.Fragment>
                      )}

                    {/* Manifest Status Pending - Commit Form */}
                    {this.state.manifestStatus === 'pending' &&
                      this.state.isManifestCloseOut && (
                        <React.Fragment>
                          <div className='form-group'>
                            <label htmlFor='manifestCommitStatus'>
                              Select Status *
                            </label>
                            <select
                              className='form-control'
                              id='manifestCommitStatus'
                              value='In Use'
                              disabled
                              required
                            >
                              <option value='In Use'>In Use</option>
                            </select>
                          </div>

                          <div className='form-group'>
                            <label htmlFor='exampleFormControlInput1'>
                            Type of Assignment *
                            </label>
                            <select
                              className='form-control'
                              name='tempAssignmentType'
                              value={this.state.tempAssignmentType}
                              ref='AssignmentType'
                              onChange={this.handleSelect}
                              required
                            >
                              <option value=''>Choose Type of Assignment</option>
                              {this.state.assigmentCategoryOptions.map(
                                (item, index) => (
                                  <option key={index} value={item.id}>
                                    {item.value}
                                  </option>
                                ),
                              )}
                            </select>
                          </div>

                          <AllManifest
                            resourceId={this.state.id}
                            onSelect={(manifestId) => {
                              this.setState({
                                fireHistoryManifestId: manifestId,
                              });
                            }}
                            setIncident={(incident) => {
                              this.setState({ projectName: incident });
                            }}
                          />

                          <div className='form-group name-list-wrapper'>
                            <label htmlFor='exampleFormControlInput1'>
                              Incident Name *
                            </label>
                            <input
                              required
                              ref='ProjectName'
                              name='projectName'
                              value={this.state.projectName}
                              onChange={this.handleChange}
                              type='text'
                              className='form-control'
                              disabled
                              readOnly
                            />
                          </div>
                          <div className='form-group name-list-wrapper'>
                            <label htmlFor='exampleFormControlInput1'>
                              Location
                            </label>
                            <input
                              ref='Location'
                              name='location'
                              value={this.state.location}
                              onChange={this.handleChange}
                              type='text'
                              className='form-control'
                            />
                          </div>
                          <div className='form-group'>
                            <label htmlFor='exampleFormControlInput1'>
                              Complexity
                            </label>
                            <select
                              className='form-control'
                              id='exampleFormControlSelect1'
                              name='complexity'
                              value={this.state.complexity}
                              onChange={this.handleChange}
                            >
                              <option value=''>Choose Complexity Level</option>
                              {complexity.map((item, index) => (
                                <option key={index} value={item.value}>
                                  {item.value}
                                </option>
                              ))}
                            </select>
                          </div>
                          <div className='form-group'>
                            <label htmlFor='exampleFormControlInput1'>
                              Fuel Type
                            </label>
                            <select
                              className='form-control'
                              id='exampleFormControlSelect1'
                              name='fuel_type'
                              value={this.state.fuel_type}
                              onChange={this.handleChange}
                            >
                              <option value=''>Choose Fuel Type</option>
                              {fuelType.map((item, index) => (
                                <option key={index} value={item.value}>
                                  {item.value}- {item.label}
                                </option>
                              ))}
                            </select>
                          </div>
                          <div className='form-group'>
                            <label htmlFor='exampleFormControlInput1'>
                              Fire Size
                            </label>
                            <select
                              className='form-control'
                              id='exampleFormControlSelect1'
                              name='fire_size'
                              value={this.state.fire_size}
                              onChange={this.handleChange}
                            >
                              <option value=''>Choose Fire Size</option>
                              {fireSize.map((item, index) => (
                                <option key={index} value={item.value}>
                                  {item.value}- {item.label}
                                </option>
                              ))}
                            </select>
                          </div>
                          <div className='form-group'>
                            <label htmlFor='exampleFormControlInput1'>
                              Date On *
                            </label>
                            <span className='date-outer'>
                              <span
                                onClick={() => {
                                  this.refs.dateon.setFocus();
                                }}
                                className='datepicker-image'
                              >
                                <img
                                  src={
                                    require('../assets/images/icon_calendar.svg')
                                      .default
                                  }
                                />
                              </span>
                              <DatePicker
                                className='txt '
                                ref='dateon'
                                id='Dateon'
                                name='Dateon'
                                selected={this.state.onDate}
                                onChange={(date) => {
                                  this.setState({ onDate: date }, () => {
                                    this.renderTotalShifts(
                                      this.state.onDate,
                                      this.state.offDate,
                                    );
                                  });
                                }}
                                showMonthDropdown
                                showYearDropdown
                                dropdownMode='select'
                                placeholderText='Select Date'
                                onKeyDown={(e) => e.preventDefault()}
                                minDate={moment()}
                              />
                            </span>
                          </div>
                          <div className='form-group'>
                            <label htmlFor='exampleFormControlTextarea1'>
                              Notes
                            </label>
                            <textarea
                              ref='note'
                              name='projectNote'
                              value={this.state.projectNote}
                              onChange={this.handleChange}
                              className='form-control'
                              rows='3'
                            ></textarea>
                          </div>
                        </React.Fragment>
                      )}

                    {/* Regular Assignment Status Fields - Only show when NOT manifest close out or commit */}
                    {!(
                      (this.state.manifestStatus === 'inuse' ||
                        this.state.manifestStatus === 'pending') &&
                      this.state.isManifestCloseOut
                    ) && (
                        <React.Fragment>
                          <div className='form-group'>
                            <label htmlFor='exampleFormControlInput1'>
                              Select Status *
                            </label>
                            <select
                              className='form-control'
                              id='exampleFormControlSelect1'
                              value={
                                this.state.editMode
                                  ? this.state.currentAssignmentStatus
                                  : this.state.tempAssignmentStatus
                              }
                              onChange={this.handleAssignmentChange}
                              disabled={this.state.editMode}
                              required
                            >
                              {!this.state.editMode &&
                                assignmentStatuses
                                  .filter(
                                    (status) =>
                                      status.value !==
                                      this.state.currentAssignmentStatus,
                                  )
                                  .map((status) => (
                                    <option
                                      key={status.value}
                                      value={status.value}
                                    >
                                      {status.label}
                                    </option>
                                  ))}
                              {this.state.editMode && (
                                <option
                                  value={this.state.currentAssignmentStatus}
                                >
                                  {this.state.currentAssignmentStatus ||
                                    'Assignment Status'}
                                </option>
                              )}
                            </select>
                          </div>

                          {this.state.tempAssignmentStatus === 'Committed' && (
                            <React.Fragment>
                              <div className='form-group'>
                                <label htmlFor='exampleFormControlInput1'>
                                  Type of Assignment *
                                </label>
                                <select
                                  className='form-control'
                                  name='tempAssignmentType'
                                  value={this.state.tempAssignmentType}
                                  ref='AssignmentType'
                                  onChange={this.handleSelect}
                                  required
                                >
                                  <option value=''>Choose Type of Assignment</option>
                                  {this.state.assigmentCategoryOptions.map(
                                    (item, index) => (
                                      <option key={index} value={item.id}>
                                        {item.value}
                                      </option>
                                    ),
                                  )}
                                </select>
                              </div>

                              {!this.state.editMode && (
                                <AllManifest
                                  resourceId={this.state.id}
                                  onSelect={(manifestId) => {
                                    this.setState({
                                      typeSlug: manifestId
                                        ? FIRE_HISTORY_TYPE_SLUG?.WITH_MANIFEST
                                        : null,
                                      fireHistoryManifestId: manifestId,
                                    });
                                  }}
                                  setIncident={(incident) => {
                                    this.setState({ projectName: incident });
                                  }}
                                />
                              )}

                              {(this.state.projectId == null ||
                                (this.state.editMode === true &&
                                  this.state.initialStatusId === 3)) && (
                                  <div>
                                    <div className='form-group name-list-wrapper'>
                                      <label htmlFor='exampleFormControlInput1'>
                                        Incident Name *
                                      </label>
                                      <input
                                        required
                                        ref='ProjectName'
                                        name='projectName'
                                        value={this.state.projectName}
                                        onChange={this.handleChange}
                                        type='text'
                                        className='form-control'
                                        disabled
                                        readOnly
                                      />
                                    </div>
                                    <div className='form-group name-list-wrapper'>
                                      <label htmlFor='exampleFormControlInput1'>
                                        Location
                                      </label>
                                      <input
                                        ref='Location'
                                        name='location'
                                        value={this.state.location}
                                        onChange={this.handleChange}
                                        type='text'
                                        className='form-control'
                                      />
                                    </div>
                                    <div className='form-group'>
                                      <label htmlFor='exampleFormControlInput1'>
                                        Complexity
                                      </label>
                                      <select
                                        className='form-control'
                                        id='exampleFormControlSelect1'
                                        name='complexity'
                                        value={this.state.complexity}
                                        onChange={this.handleChange}
                                      >
                                        <option value=''>
                                          Choose Complexity Level
                                        </option>
                                        {complexity.map((item, index) => (
                                          <option key={index} value={item.value}>
                                            {item.value}
                                          </option>
                                        ))}
                                      </select>
                                    </div>
                                    <div className='form-group'>
                                      <label htmlFor='exampleFormControlInput1'>
                                        Fuel Type
                                      </label>
                                      <select
                                        className='form-control'
                                        id='exampleFormControlSelect1'
                                        name='fuel_type'
                                        value={this.state.fuel_type}
                                        onChange={this.handleChange}
                                      >
                                        <option value=''>Choose Fuel Type</option>
                                        {fuelType.map((item, index) => (
                                          <option key={index} value={item.value}>
                                            {item.value}- {item.label}
                                          </option>
                                        ))}
                                      </select>
                                    </div>
                                    <div className='form-group'>
                                      <label htmlFor='exampleFormControlInput1'>
                                        Fire Size
                                      </label>
                                      <select
                                        className='form-control'
                                        id='exampleFormControlSelect1'
                                        name='fire_size'
                                        value={this.state.fire_size}
                                        onChange={this.handleChange}
                                      >
                                        <option value=''>Choose Fire Size</option>
                                        {fireSize.map((item, index) => (
                                          <option key={index} value={item.value}>
                                            {item.value}- {item.label}
                                          </option>
                                        ))}
                                      </select>
                                    </div>
                                    <div className='form-group'>
                                      <label htmlFor='exampleFormControlInput1'>
                                        Date On *
                                      </label>
                                      <span className='date-outer'>
                                        <span
                                          onClick={() => {
                                            this.refs.dateon.setFocus();
                                          }}
                                          className='datepicker-image'
                                        >
                                          <img
                                            src={
                                              require('../assets/images/icon_calendar.svg')
                                                .default
                                            }
                                          />
                                        </span>
                                        <DatePicker
                                          className='txt '
                                          ref='dateon'
                                          id='Dateon'
                                          name='Dateon'
                                          selected={this.state.onDate}
                                          onChange={(date) => {
                                            this.setState({ onDate: date }, () => {
                                              if (
                                                this.state.editMode &&
                                                permList.includes(
                                                  'Edit Assignment History',
                                                )
                                              ) {
                                                this.renderTotalShifts(
                                                  this.state.onDate,
                                                  this.state.offDate,
                                                );
                                              }
                                            });
                                          }}
                                          showMonthDropdown
                                          showYearDropdown
                                          dropdownMode='select'
                                          placeholderText='Select Date'
                                          onKeyDown={(e) => e.preventDefault()}
                                        />
                                      </span>
                                    </div>
                                    {this.state.editMode &&
                                      permList.includes(
                                        'Edit Assignment History',
                                      ) && (
                                        <React.Fragment>
                                          {this.state.manifestStatus !==
                                            'inuse' && (
                                              <div className='form-group'>
                                                <label htmlFor='exampleFormControlInput1'>
                                                  Date Off{' '}
                                                  {this.state.offDate ? '*' : ''}
                                                </label>
                                                <span className='date-outer'>
                                                  <span
                                                    onClick={() => {
                                                      this.refs.dateoff.setFocus();
                                                    }}
                                                    className='datepicker-image'
                                                  >
                                                    <img
                                                      src={
                                                        require('../assets/images/icon_calendar.svg')
                                                          .default
                                                      }
                                                    />
                                                  </span>
                                                  <DatePicker
                                                    className='txt '
                                                    ref='dateoff'
                                                    id='Dateoff'
                                                    name='assignDate'
                                                    selected={this.state.offDate}
                                                    onChange={(date) => {
                                                      this.setState(
                                                        { offDate: date },
                                                        () =>
                                                          this.renderTotalShifts(
                                                            this.state.onDate,
                                                            this.state.offDate,
                                                          ),
                                                      );
                                                    }}
                                                    minDate={this.state.onDate}
                                                    showMonthDropdown
                                                    showYearDropdown
                                                    dropdownMode='select'
                                                    placeholderText='Select Date'
                                                    onKeyDown={(e) =>
                                                      e.preventDefault()
                                                    }
                                                  />
                                                </span>
                                              </div>
                                            )}
                                          <div className='form-group name-list-wrapper'>
                                            <label htmlFor='exampleFormControlInput1'>
                                              Hotline Shifts
                                            </label>
                                            <input
                                              ref='Location'
                                              name='hotline_shifts'
                                              value={this.state.hotline_shifts}
                                              onChange={this.handleChange}
                                              type='number'
                                              className='form-control'
                                              min={0}
                                              onWheel={this.handleOnWheel}
                                              onKeyDown={preventNegativeValueInDocs}
                                            />
                                          </div>
                                          <div className='form-group'>
                                            <label htmlFor='exampleFormControlInput1'>
                                              Total Shifts
                                            </label>
                                            <input
                                              type='number'
                                              name='projectShift'
                                              value={this.state.projectShift}
                                              disabled
                                              ref='totalShifts'
                                              className='form-control'
                                            />
                                          </div>
                                        </React.Fragment>
                                      )}
                                  </div>
                                )}
                            </React.Fragment>
                          )}

                          {/* Unavailable */}
                          {this.state.tempAssignmentStatus === 'Unavailable' && (
                            <React.Fragment>
                              <div className='form-group'>
                                <label htmlFor='unavailable_reason'>
                                  Unavailable Reason *
                                </label>
                                <select
                                  className='form-control'
                                  id='unavailable_reason_id'
                                  name='unavailable_reason_id'
                                  value={this.state.unavailable_reason_id}
                                  onChange={this.handleChange}
                                  required
                                >
                                  <option value=''>-no reason-</option>
                                  {this.state.unavailable_reasons.map(
                                    (reason) => {
                                      return (
                                        <option value={reason.id} key={reason.id}>
                                          {reason.value}
                                        </option>
                                      );
                                    },
                                  )}
                                </select>
                              </div>
                              <div className='form-group'>
                                <label htmlFor='exampleFormControlInput1'>
                                  Unavailable Start Date *
                                </label>
                                <span className='date-outer'>
                                  <DatePicker
                                    className='txt'
                                    ref='unavailable_start_date'
                                    id='unavailable_start_date'
                                    name='unavailable_start_date'
                                    selected={this.state.unavailable_start_date}
                                    onChange={(date) =>
                                      this.setState({
                                        unavailable_start_date: date,
                                      })
                                    }
                                    showMonthDropdown
                                    showYearDropdown
                                    dropdownMode='select'
                                    placeholderText='Select Date'
                                    required
                                    disabled
                                    onKeyDown={(e) => e.preventDefault()}
                                  />
                                </span>
                              </div>

                              <div className='form-group'>
                                <label htmlFor='exampleFormControlInput1'>
                                  Unavailable End Date *
                                </label>
                                <span className='date-outer'>
                                  <span
                                    onClick={() => {
                                      this.refs.unavailable_end_date.setFocus();
                                    }}
                                    className='datepicker-image'
                                  >
                                    <img
                                      src={
                                        require('../assets/images/icon_calendar.svg')
                                          .default
                                      }
                                    />
                                  </span>
                                  <DatePicker
                                    className='txt'
                                    ref='unavailable_end_date'
                                    id='unavailable_end_date'
                                    name='unavailable_end_date'
                                    selected={this.state.unavailable_end_date}
                                    onChange={(date) =>
                                      this.setState({
                                        unavailable_end_date: date,
                                      })
                                    }
                                    showMonthDropdown
                                    showYearDropdown
                                    dropdownMode='select'
                                    placeholderText='Select Date'
                                    required
                                    onKeyDown={(e) => e.preventDefault()}
                                    minDate={moment()}
                                  />
                                </span>
                              </div>
                            </React.Fragment>
                          )}

                          {/* Available */}
                          {this.state.tempAssignmentStatus === 'Available' && (
                            <React.Fragment>
                              <div className='form-group'>
                                <label htmlFor='exampleFormControlInput1'>
                                  Unavailable End Date *
                                </label>
                                <span className='date-outer'>
                                  <span
                                    onClick={() => {
                                      this.refs.unavailable_end_date.setFocus();
                                    }}
                                    className='datepicker-image'
                                  >
                                    <img
                                      src={
                                        require('../assets/images/icon_calendar.svg')
                                          .default
                                      }
                                    />
                                  </span>
                                  <DatePicker
                                    className='txt'
                                    ref='unavailable_end_date'
                                    id='unavailable_end_date'
                                    name='unavailable_end_date'
                                    selected={this.state.unavailable_end_date}
                                    onChange={(date) =>
                                      this.setState({
                                        unavailable_end_date: date,
                                      })
                                    }
                                    showMonthDropdown
                                    showYearDropdown
                                    dropdownMode='select'
                                    placeholderText='Select Date'
                                    required
                                    onKeyDown={(e) => e.preventDefault()}
                                    minDate={moment()}
                                  />
                                </span>
                              </div>
                            </React.Fragment>
                          )}

                          {(this.state.projectId == null ||
                            this.state.editMode == true) && (
                              <div className='form-group'>
                                <label htmlFor='exampleFormControlTextarea1'>
                                  Notes
                                </label>
                                <textarea
                                  ref='note'
                                  name='projectNote'
                                  value={this.state.projectNote}
                                  onChange={this.handleChange}
                                  className='form-control'
                                  rows='3'
                                ></textarea>
                              </div>
                            )}
                        </React.Fragment>
                      )}

                    <div className='submit-area' style={{ marginTop: 15 }}>
                      <button type='submit' className='btn btn-primary'>
                        Submit
                      </button>
                      <button
                        onClick={(event) => {
                          this.closeStatusPopup();
                          event.preventDefault();
                        }}
                        className='btn btn-primary cancel'
                      >
                        Cancel
                      </button>
                    </div>
                  </form>
                </div>
              </div>

              {permList.includes('List Resource Manifests') && (
                <div
                  ref={this.manifestTableRef}
                  className='manifest-table-container'
                >
                  <Accordian
                    title='Manifest'
                    persistKey='resource-accordion-manifest'
                    extraTitleContent={
                      <button
                        className='view_all_button'
                        onClick={() =>
                          (window.location.href = `/resources/${this.state.id}/listmanifests`)
                        }
                      >
                        View All
                      </button>
                    }
                  >
                    <div className='resource_accordion_wrapper'>
                      <div className='mobile_hide_resource_accordion'>
                        <div className='manifest_list outer_list resource-details-manifest'>
                          <div className='list_header'>
                            <div className='list_item_head'>Contract Type</div>
                            <div className='list_item_head'>
                              Contract Number
                            </div>
                            <div className='list_item_head'>Incident Name</div>
                            <div className='list_item_head'>
                              Resource Number
                            </div>
                            <div className='list_item_head'>RO</div>
                            <div className='list_item_head'>Date Added</div>
                            <div className='list_item_head'>Date Assigned</div>
                            <div className='list_item_head' />
                            <div className='list_item_head' />
                          </div>
                          {manifestsOption}
                          {paginationHtml}
                        </div>
                      </div>
                      {/* Mobile view - render each manifest directly */}
                      {(() => {
                        const manifestData =
                          this.state.ManifestListV1 || this.state.ManifestList;

                        if (!manifestData || manifestData.length === 0) {
                          return null;
                        }

                        const manifests = manifestData;

                        return manifests.map((item, manifestIndex) => {
                          // Transform each manifest item
                          const manifest = {
                            manifestId: item.manifest_id || item.mid,
                            abbreviation: item.abbreviation || '',
                            contractNumber: item.contract_number || '-',
                            incidentName: item.incident_name || '',
                            resourceNumber: item.resource_number || '',
                            addedDate: item.added_date || '',
                            dateAssigned: item.date_assigned || '',
                            resourceOrderFormExists:
                              item.resource_order_form_exists,
                            resourceOrderName: item.resource_order_name,
                            assignmentStatus: item.assignment_status,
                            manifestAvailability: item.manifest_availability,
                            manifestStatus: item.manifest_status,
                            baseManifestId: item.bid || item.base_manifest_id,
                            hasLatestVersion: item.has_latest_version,
                            resourceOrderFormType:
                              item.resource_order_form_type,
                            resourceOrderForm: item.resource_order_form,
                            versions: item.versions || [],
                          };

                          const hasMultipleVersions =
                            manifest.versions.length > 1;
                          const actionId = `${manifest.manifestId}-${manifestIndex}`;

                          return (
                            <React.Fragment key={manifestIndex}>
                              <hr />
                              <CustomToolTip
                                label={this.getStatusLabel(
                                  manifest.manifestAvailability,
                                )}
                                customClass={'fs-tooltip'}
                              >
                                <div className='for_mobile_manifest_list'>
                                  <div
                                    className={`manifest_items manifest-status-${this.getStatusClass(
                                      manifest.manifestAvailability,
                                    )}`}
                                  >
                                    <div className='status_item'>
                                      <div className='list_item'>
                                        <strong>Contract Type</strong>
                                      </div>
                                      <div className='list_item'>
                                        {manifest.abbreviation || '-'}
                                      </div>
                                    </div>
                                    <div className='status_item'>
                                      <div className='list_item'>
                                        <strong>Contract Number</strong>
                                      </div>
                                      <div className='list_item'>
                                        {manifest.contractNumber || '-'}
                                      </div>
                                    </div>
                                    <div className='status_item'>
                                      <div className='list_item'>
                                        <strong>Incident Name</strong>
                                      </div>
                                      <div className='list_item'>
                                        {manifest.incidentName || '-'}
                                      </div>
                                    </div>
                                    <div className='status_item'>
                                      <div className='list_item'>
                                        <strong>Resource Number</strong>
                                      </div>
                                      <div className='list_item'>
                                        {manifest.resourceNumber || '-'}
                                      </div>
                                    </div>
                                    <div className='status_item'>
                                      <div className='list_item'>
                                        <strong>RO</strong>
                                      </div>
                                      <div className='list_item'>
                                        {manifest.resourceOrderName || '-'}
                                      </div>
                                    </div>
                                    <div className='status_item'>
                                      <div className='list_item'>
                                        <strong>Date Added</strong>
                                      </div>
                                      <div className='list_item'>
                                        {manifest.addedDate
                                          ? formatDate(manifest.addedDate)
                                          : '-'}
                                      </div>
                                    </div>
                                    <div className='status_item'>
                                      <div className='list_item'>
                                        <strong>Date Assigned</strong>
                                      </div>
                                      <div className='list_item'>
                                        {manifest.dateAssigned
                                          ? formatDate(manifest.dateAssigned)
                                          : '-'}
                                      </div>
                                    </div>
                                    {hasMultipleVersions && (
                                      <div className='status_item'>
                                        <div className='list_item'>
                                          <strong>History</strong>
                                        </div>
                                        <div className='list_item'>
                                          <img
                                            src={
                                              require('../assets/icons/history_24dp.svg')
                                                .default
                                            }
                                            alt='View manifest'
                                            className='manifest-history-icon'
                                            style={{ cursor: 'pointer' }}
                                            onClick={() => {
                                              this.viewManifest(
                                                manifest.manifestId,
                                                manifest.baseManifestId,
                                              );
                                            }}
                                          />
                                        </div>
                                      </div>
                                    )}
                                    <div className='status_item mobile_action_row'>
                                      <div
                                        className='list_item action_icon mobile_action_icon'
                                        onClick={this.viewAction.bind(
                                          this,
                                          actionId,
                                        )}
                                      ></div>
                                    </div>
                                  </div>
                                  {this.state.action_id === actionId && (
                                    <div
                                      className={
                                        this.state.viewStatus
                                          ? 'action_list'
                                          : 'action_list hide'
                                      }
                                    >
                                      {permList.includes(
                                        'Manage Manifests',
                                      ) && (
                                          <>
                                            <p
                                              onClick={this.editManifest.bind(
                                                this,
                                                manifest.manifestId,
                                                manifest.baseManifestId,
                                              )}
                                            >
                                              Edit
                                            </p>
                                            {this.state
                                              .resourceAvailabilityStatus ===
                                              'available' && (
                                                <p
                                                  onClick={this.duplicateManifest.bind(
                                                    this,
                                                    manifest,
                                                  )}
                                                >
                                                  Duplicate
                                                </p>
                                              )}
                                            <p
                                              onClick={this.printManifest.bind(
                                                this,
                                                manifest.manifestId,
                                              )}
                                            >
                                              Print
                                            </p>
                                            <p
                                              onClick={this.deleteOpenModal.bind(
                                                this,
                                                manifest.manifestId,
                                              )}
                                            >
                                              Delete
                                            </p>
                                          </>
                                        )}
                                      <p
                                        onClick={this.viewManifest.bind(
                                          this,
                                          manifest.manifestId,
                                          manifest.baseManifestId,
                                        )}
                                      >
                                        View
                                      </p>
                                      {permList.includes(
                                        'Manage Manifests',
                                      ) && (
                                          <p
                                            onClick={this.emailOpenModal.bind(
                                              this,
                                              manifest.manifestId,
                                            )}
                                          >
                                            Email
                                          </p>
                                        )}
                                      {permList.includes(
                                        'Manage Employees',
                                      ) && (
                                          <p
                                            onClick={this.printFireCards.bind(
                                              this,
                                              manifest.manifestId,
                                            )}
                                          >
                                            Print Fire Cards
                                          </p>
                                        )}
                                      {permList.includes(
                                        'Manage Employees',
                                      ) && (
                                          <p
                                            onClick={this.emailFireCardsOpenModal.bind(
                                              this,
                                            )}
                                          >
                                            Email Fire Cards
                                          </p>
                                        )}
                                      {manifest.assignmentStatus == 2 && (
                                        <p
                                          title='Unassign Old Manifest'
                                          onClick={this.unassignOldManifest.bind(
                                            this,
                                            manifest.manifestId,
                                            manifestIndex,
                                          )}
                                        >
                                          Unassign
                                        </p>
                                      )}
                                    </div>
                                  )}
                                </div>
                              </CustomToolTip>
                            </React.Fragment>
                          );
                        });
                      })()}
                      <div className='for_mobile_manifest_list'>
                        {paginationHtml}
                      </div>
                    </div>
                  </Accordian>
                </div>
              )}

              {/* History Accordion */}
              {
                <Accordian
                  title='History'
                  persistKey='resource-accordion-history'
                >
                  <div className='resource_accordion_wrapper'>
                    <div className='history_lists outer_list '>
                      <div className='mobile_hide_resource_accordion'>
                        <div className='list_header'>
                          <div className='list_item_head'>
                            Choose Type of Assignment
                          </div>
                          <div className='list_item_head'>Incident Name</div>
                          <div className='list_item_head'>Location</div>
                          <div className='list_item_head'>Complexity</div>
                          <div className='list_item_head'>Fuel Type</div>
                          <div className='list_item_head'>Fire Size</div>
                          <div className='list_item_head'>Hotline Shifts</div>
                          <div className='list_item_head'>Date On</div>
                          <div className='list_item_head'>Date Off</div>
                          <div className='list_item_head list_item_head_trash'></div>
                          <div className='list_item_head list_item_head_trash'></div>
                          <div className='list_item_head list_item_head_trash'></div>
                        </div>
                        <div className='history_items'>
                          {this.state.assigmentStatusHistory?.data?.length >
                            0 ? (
                            this.state.assigmentStatusHistory.data.map(
                              (item, index) => (
                                <div
                                  className='status_item resource_history'
                                  key={index}
                                >
                                  <div className='list_item'>
                                    {item.incident_projects
                                      ? item.incident_projects.assignment_type
                                      : '-'}
                                  </div>
                                  <div className='list_item'>
                                    {item.incident_projects
                                      ? item.incident_projects.name
                                      : '-'}
                                  </div>
                                  <div className='list_item'>
                                    {item.incident_projects?.location
                                      ? item.incident_projects.location
                                      : '-'}
                                  </div>
                                  <div className='list_item'>
                                    {item.incident_projects?.complexity
                                      ? item.incident_projects.complexity
                                      : '-'}
                                  </div>
                                  <div className='list_item'>
                                    {item.incident_projects?.fuel_type
                                      ? item.incident_projects.fuel_type
                                      : '-'}
                                  </div>
                                  <div className='list_item'>
                                    {item.incident_projects?.fire_size
                                      ? item.incident_projects.fire_size
                                      : '-'}
                                  </div>
                                  <div className='list_item'>
                                    {item.incident_projects?.hotline_shifts
                                      ? item.incident_projects.hotline_shifts
                                      : '-'}
                                  </div>
                                  <div className='list_item'>
                                    {item.incident_projects
                                      ? formatDate(
                                        item.incident_projects.date_on,
                                      )
                                      : item.unavailable_start_date
                                        ? formatDate(
                                          item.unavailable_start_date,
                                        )
                                        : '-'}
                                  </div>
                                  <div className='list_item'>
                                    {item.incident_projects
                                      ? formatDate(
                                        item.incident_projects.date_off,
                                      )
                                      : item.unavailable_end_date
                                        ? formatDate(item.unavailable_end_date)
                                        : '-'}
                                  </div>
                                  <div className='list_item list_item_trash'>
                                    <Link
                                      to={`/employee-fire-history/${item.id}`}
                                    >
                                      <img
                                        src={
                                          require('../assets/images/person-black.svg')
                                            .default
                                        }
                                        alt='Person Icon'
                                      />
                                    </Link>
                                  </div>

                                  {permList.includes(
                                    'Edit Assignment History',
                                  ) && (
                                      <>
                                        <div className='list_item list_item_trash'>
                                          <a
                                            href='#'
                                            onClick={() => {
                                              this.editResourceHistory(item);
                                            }}
                                          >
                                            <img
                                              src={
                                                require('../assets/images/edit-black.svg')
                                                  .default
                                              }
                                            />
                                          </a>
                                        </div>
                                      </>
                                    )}
                                </div>
                              ),
                            )
                          ) : (
                            <div className='status_item resource_history'>
                              No data to display.
                            </div>
                          )}
                        </div>
                        {paginationHistoryHtml}
                      </div>
                    </div>
                    {this.state.assigmentStatusHistory.data.map(
                      (item, index) => (
                        <React.Fragment key={index}>
                          <hr></hr>
                          <div className='for_mobile_history_list'>
                            <div className='history_items'>
                              <div className='status_item'>
                                <div className='list_item'>
                                  <strong>Choose Type of Assignment</strong>
                                </div>
                                <div className='list_item'>
                                  {item.incident_projects
                                    ? item.incident_projects.assignment_type
                                    : '-'}
                                </div>
                              </div>
                              <div className='status_item'>
                                <div className='list_item'>
                                  <strong>Incident Name</strong>
                                </div>
                                <div className='list_item'>
                                  {item.incident_projects
                                    ? item.incident_projects.name
                                    : '-'}
                                </div>
                              </div>
                              <div className='status_item'>
                                <div className='list_item'>
                                  <strong>Location</strong>
                                </div>
                                <div className='list_item'>
                                  {item.incident_projects?.location
                                    ? item.incident_projects.location
                                    : '-'}
                                </div>
                              </div>
                              <div className='status_item'>
                                <div className='list_item'>
                                  <strong>Complexity</strong>
                                </div>
                                <div className='list_item'>
                                  {item.incident_projects?.complexity
                                    ? item.incident_projects.complexity
                                    : '-'}
                                </div>
                              </div>
                              <div className='status_item'>
                                <div className='list_item'>
                                  <strong>Fuel Type</strong>
                                </div>
                                <div className='list_item'>
                                  {item.incident_projects?.fuel_type
                                    ? item.incident_projects.fuel_type
                                    : '-'}
                                </div>
                              </div>
                              <div className='status_item'>
                                <div className='list_item'>
                                  <strong>Fire Size</strong>
                                </div>
                                <div className='list_item'>
                                  {item.incident_projects?.fire_size
                                    ? item.incident_projects.fire_size
                                    : '-'}
                                </div>
                              </div>
                              <div className='status_item'>
                                <div className='list_item'>
                                  <strong>Hotline Shifts</strong>
                                </div>
                                <div className='list_item'>
                                  {item.incident_projects?.hotline_shifts
                                    ? item.incident_projects.hotline_shifts
                                    : '-'}
                                </div>
                              </div>
                              <div className='status_item'>
                                <div className='list_item'>
                                  <strong>Date On</strong>
                                </div>
                                <div className='list_item'>
                                  {item.incident_projects
                                    ? formatDate(item.incident_projects.date_on)
                                    : item.unavailable_start_date
                                      ? formatDate(item.unavailable_start_date)
                                      : '-'}
                                </div>
                              </div>
                              <div className='status_item'>
                                <div className='list_item'>
                                  <strong>Date Off</strong>
                                </div>
                                <div className='list_item'>
                                  {item.incident_projects
                                    ? formatDate(
                                      item.incident_projects.date_off,
                                    )
                                    : item.unavailable_end_date
                                      ? formatDate(item.unavailable_end_date)
                                      : '-'}
                                </div>
                              </div>
                              <div className='status_item'>
                                <div className='list_item'>
                                  <div className='list_item list_item_trash'>
                                    <Link
                                      to={`/employee-fire-history/${item.id}`}
                                    >
                                      <img
                                        style={{
                                          display:
                                            item.status != 3 ? 'none' : '',
                                        }}
                                        src={
                                          require('../assets/images/person-black.svg')
                                            .default
                                        }
                                        alt='Person Icon'
                                      />
                                    </Link>
                                  </div>
                                </div>

                                {permList.includes(
                                  'Edit Assignment History',
                                ) && (
                                    <>
                                      <div className='list_item'>
                                        <div className='list_item list_item_trash'>
                                          <a
                                            href='#'
                                            onClick={() => {
                                              this.editResourceHistory(item);
                                            }}
                                          >
                                            <img
                                              src={
                                                require('../assets/images/edit-black.svg')
                                                  .default
                                              }
                                            />
                                          </a>
                                        </div>
                                      </div>
                                    </>
                                  )}
                              </div>
                            </div>
                          </div>
                        </React.Fragment>
                      ),
                    )}
                    <div className='for_mobile_history_list'>
                      {paginationHistoryHtml}
                    </div>
                  </div>
                </Accordian>
              }

              {/** Combined Accordian for Resource Orders */}
              {
                <Accordian
                  title='Resource Order'
                  persistKey='resource-accordion-resource-orders'
                >
                  <div className='resource_accordion_wrapper'>
                    <div className='ro_list outer_list'>
                      <div className='list_header table-view'>
                        <div className='list_item_head'>Name</div>
                        <div className='list_item_head'>Created Date</div>
                        <div className='list_item_head'>Resources</div>
                        {permList.includes('Resource Order Forms') && (
                          <>
                            <div className='list_item_head list_item_head_trash'></div>
                            <div className='list_item_head list_item_head_trash'></div>
                          </>
                        )}
                      </div>
                      <div className='history_lists outer_list'>
                        <div>
                          {this.state.resourceOrderData?.length ? (
                            this.state.resourceOrderData.map((item, index) => (
                              <div
                                className='status_item resource_history'
                                key={`${item.type}-${item.id}-${index}`}
                              >
                                <div className='list_item ro_table_row'>
                                  <div
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      gap: '4px',
                                    }}
                                  >
                                    <img
                                      src={
                                        item.type === 'created'
                                          ? require('../assets/images/insert-drive-file.svg')
                                            .default
                                          : require('../assets/images/upload-file.svg')
                                            .default
                                      }
                                      alt={
                                        item.type === 'created'
                                          ? 'Created'
                                          : 'Uploaded'
                                      }
                                      style={{ width: '20px', height: '20px' }}
                                    />
                                    {item.type === 'created' ? (
                                      <a
                                        href='#'
                                        onClick={(event) => {
                                          this.viewCreatedRO(item?.id);
                                          event.preventDefault();
                                        }}
                                      >
                                        {item.displayName || '-'}
                                      </a>
                                    ) : (
                                      <a
                                        href={`${config?.s3BucketUrl}${item?.file_hash}`}
                                        rel='noopener noreferrer'
                                        target='_blank'
                                      >
                                        {item.displayName || '-'}
                                      </a>
                                    )}
                                  </div>
                                </div>
                                <div className='list_item ro_table_row'>
                                  {formatDate(item.created_at) || '-'}
                                </div>
                                <div className='list_item ro_table_row'>
                                  {item?.resources
                                    ?.map((resource) => resource?.resource_name)
                                    .join(', ')}
                                </div>
                                {permList.includes('Resource Order Forms') && (
                                  <>
                                    <div className='list_item list_item_trash'>
                                      <a
                                        href='#'
                                        onClick={() =>
                                          item.type === 'created'
                                            ? this.handleEditRof(item?.id)
                                            : this.showEditRoPopup(item)
                                        }
                                      >
                                        <img
                                          src={
                                            require('../assets/images/edit-black.svg')
                                              .default
                                          }
                                          alt=''
                                        />
                                      </a>
                                    </div>
                                    <div className='list_item list_item_trash'>
                                      <a
                                        href='#'
                                        onClick={(event) => {
                                          this.setState({
                                            selectedRO: {
                                              id: item?.id,
                                              type:
                                                item.type === 'created' ? 1 : 2,
                                            },
                                            deleteROModal: true,
                                          });
                                          event.preventDefault();
                                        }}
                                      >
                                        <img
                                          alt=''
                                          src={
                                            require('../assets/images/trash.svg')
                                              .default
                                          }
                                        />
                                      </a>
                                    </div>
                                  </>
                                )}
                              </div>
                            ))
                          ) : (
                            <div className='status_item resource_history no_ro_data'>
                              <p>No Resource Orders found!</p>
                            </div>
                          )}
                          {this.state.resourceOrderData?.length > 0 && (
                            <div className='fs-pagination-wrapper-outer customised-pagination right-align ro-paginate'>
                              <ReactPaginate
                                forcePage={this.state.roPage}
                                previousLabel={''}
                                nextLabel={''}
                                breakLabel={'...'}
                                breakClassName={'break-me'}
                                pageCount={this.state.roLastPage}
                                marginPagesDisplayed={2}
                                pageRangeDisplayed={5}
                                onPageChange={(data) =>
                                  this.handleROPageChange(data)
                                }
                                containerClassName={'pagination'}
                                subContainerClassName={'pages pagination'}
                                activeClassName={'active'}
                              />
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </Accordian>
              }

              {/* Inventory Accordion */}
              {permList.includes('Inventory') && (
                <Accordian
                  title='Inventory'
                  persistKey='resource-accordion-inventory'
                >
                  <div className='resource_accordion_wrapper'>
                    <div className='employee_list outer_list'>
                      <div className='list_header resource-view'>
                        <div className='list_item_head image-holder'>
                          Inventory
                        </div>
                        <div className='list_item_head'>Item Name</div>
                        <div className='list_item_head'>Cost</div>
                        <div className='list_item_head'>Assigned To</div>
                      </div>
                      {inventoryList.map((item, index) => {
                        return (
                          <div className='empployeeItem' key={index}>
                            <div className='emp_link_resource crew_wrapper resource_details bg-fill'>
                              <div className='employee_item '>
                                <div className='list_item image-holder'>
                                  <span className='pos_counter'>
                                    {(inventoryPage - 1) * inventoryPerPage +
                                      index +
                                      1}
                                  </span>
                                  <img
                                    alt=''
                                    className={`${item.user?.hash ? 'Available' : ''
                                      }`}
                                    src={this.getInventoryPhotoUrl(item.pic, item)}
                                    onError={this.onInventoryImageError.bind(this, item)}
                                  />
                                </div>
                                <div className='list_item item_width'>
                                  <Link
                                    className='link'
                                    to={`/inventory/inventory-view/${item.id}`}
                                  >
                                    {item.unique_id}
                                  </Link>
                                </div>
                                <div className='list_item item_width'>
                                  {item.cost || '--'}
                                </div>
                                <div className='list_item item_width'>
                                  {item.user ? (
                                    <Link
                                      className='link'
                                      to={`/resource-profile/${item.user.hash}/profile`}
                                    >
                                      {item.user.first_name +
                                        ' ' +
                                        item.user.last_name}
                                    </Link>
                                  ) : (
                                    '--'
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                      {this.inventoryPagination()}
                    </div>
                  </div>
                </Accordian>
              )}

              {/* Vehicles Accordion */}
              {permList.includes('List Vehicles') && (
                <Accordian
                  title='Vehicles'
                  persistKey='resource-accordion-vehicles'
                >
                  <div className='resource_accordion_wrapper'>
                    <div className='vehicle_list outer_list'>
                      <div className=''>
                        <div className='list_header resource-view'>
                          <div className='list_item_head'>Unique Name</div>
                          <div className='list_item_head'>Driver</div>
                          <div className='list_item_head'>Driver License</div>
                          <div className='list_item_head appln_date'>
                            Vehicle Make/Model
                          </div>
                          <div className='list_item_head'>Vehicle License</div>
                        </div>
                        {this.state.vehiclesOption}
                      </div>
                    </div>
                  </div>
                </Accordian>
              )}

              {/* Employees Available Accordion */}
              {parseInt(localStorage.getItem('avail')) === 1 && (
                <Accordian
                  title='Employees Available'
                  persistKey='my_crew_available_employee_list'
                >
                  <div className='resource_accordion_wrapper'>
                    <div className='resource_table_wrapper'>
                      <EmployeeList
                        {...this.props}
                        permList={permList}
                        type='available'
                        className='available'
                        resourceId={this.state.id}
                        employeeList={availableEmployees}
                        startIndex={1}
                        profile={this.profile.bind(this)}
                        updateList={this.employeeListUpdated}
                      />
                    </div>
                  </div>
                </Accordian>
              )}

              {/* Pending Employees Accordion */}
              {parseInt(localStorage.getItem('avail')) === 1 && (
                <Accordian
                  title='Pending Employees'
                  persistKey='my_crew_guest_employee_list'
                >
                  <div className='resource_accordion_wrapper'>
                    <div className='resource_table_wrapper'>
                      <EmployeeList
                        {...this.props}
                        className='pending'
                        type='guest'
                        permList={permList}
                        resourceId={this.state.id}
                        employeeList={pendingEmployees}
                        startIndex={availableEmployees.length + 1}
                        profile={this.profile.bind(this)}
                        updateList={this.employeeListUpdated}
                      />
                    </div>
                  </div>
                </Accordian>
              )}

              {/* Employees Locked Accordion */}
              {parseInt(localStorage.getItem('avail')) === 1 && (
                <Accordian
                  title='Employees Locked'
                  persistKey='my_crew_locked_employee_list'
                >
                  <div className='resource_accordion_wrapper'>
                    <div className='resource_table_wrapper'>
                      <EmployeeList
                        {...this.props}
                        permList={permList}
                        className='locked'
                        type='locked'
                        resourceId={this.state.id}
                        employeeList={lockedEmployees}
                        startIndex={
                          pendingEmployees.length +
                          availableEmployees.length +
                          1
                        }
                        profile={this.profile.bind(this)}
                        updateList={this.employeeListUpdated}
                      />
                    </div>
                  </div>
                </Accordian>
              )}

              {/* Deleted Manifests Accordion */}
              {permList.includes('Manage Manifests') && (
                <Accordian
                  title='Deleted Manifests'
                  persistKey='resource-accordion-deleted-manifests'
                >
                  <div className='resource_accordion_wrapper'>
                    <div className='mobile_hide_resource_accordion'>
                      <div className='deleted_manifest_list'>
                        <div className='deleted_manifest_header'>
                          <div className='deleted_manifest_col'>
                            Contract Type
                          </div>
                          <div className='deleted_manifest_col'>
                            Contract Number
                          </div>
                          <div className='deleted_manifest_col'>
                            Incident Name
                          </div>
                          <div className='deleted_manifest_col'>
                            Resource Number
                          </div>
                          <div className='deleted_manifest_col'>Date Added</div>
                          <div className='deleted_manifest_col'>
                            Date Assigned
                          </div>
                          <div className='deleted_manifest_col'></div>
                        </div>
                        {this.state.deletedManifestsLoading ? (
                          <div className='loading-wrapper'>
                            <img
                              alt='Loader'
                              src={
                                require('../assets/images/loader.gif').default
                              }
                            />
                          </div>
                        ) : this.state.deletedManifests?.data?.length > 0 ? (
                          this.state.deletedManifests.data.map(
                            (manifest, index) => (
                              <div
                                className='deleted_manifest_row'
                                key={`deleted-manifest-${manifest.manifest_id}-${index}`}
                              >
                                <div className='deleted_manifest_cell'>
                                  {manifest.abbreviation || '-'}
                                </div>
                                <div className='deleted_manifest_cell'>
                                  {manifest.contract_number || '-'}
                                </div>
                                <div className='deleted_manifest_cell'>
                                  <div className='deleted_manifest_incident_wrapper'>
                                    <div className='deleted_manifest_incident_name'>
                                      {manifest.incident_name || '-'}
                                    </div>
                                  </div>
                                </div>
                                <div className='deleted_manifest_cell'>
                                  {manifest.resource_number || '-'}
                                </div>
                                <div className='deleted_manifest_cell'>
                                  {manifest.added_date || '-'}
                                </div>
                                <div className='deleted_manifest_cell'>
                                  {manifest.date_assigned || '-'}
                                </div>
                                <div className='deleted_manifest_cell'>
                                  <img
                                    src={
                                      require('../assets/icons/restore-icon.svg')
                                        .default
                                    }
                                    alt='Restore Manifest'
                                    title='Restore Manifest'
                                    style={{
                                      cursor: this.state.restoreManifestLoading
                                        ? 'not-allowed'
                                        : 'pointer',
                                      opacity: this.state.restoreManifestLoading
                                        ? 0.5
                                        : 1,
                                      width: '20px',
                                      height: '20px',
                                    }}
                                    onClick={() =>
                                      this.openRestoreManifestModal(
                                        manifest.manifest_id,
                                      )
                                    }
                                  />
                                </div>
                              </div>
                            ),
                          )
                        ) : (
                          <div className='deleted_manifest_row'>
                            <div
                              className='deleted_manifest_cell deleted_manifest_empty'
                              style={{
                                gridColumn: '1 / -1',
                                textAlign: 'center',
                              }}
                            >
                              No deleted manifests found
                            </div>
                          </div>
                        )}
                        {this.getDeletedManifestsPaginationHtml()}
                      </div>
                    </div>
                    {/* Mobile view for deleted manifests */}
                    <div className='deleted_manifest_mobile_list'>
                      {this.state.deletedManifestsLoading ? (
                        <div className='loading-wrapper'>
                          <img
                            alt='Loader'
                            src={require('../assets/images/loader.gif').default}
                          />
                        </div>
                      ) : this.state.deletedManifests?.data?.length > 0 ? (
                        this.state.deletedManifests.data.map(
                          (manifest, index) => (
                            <div
                              className='deleted_manifest_mobile_item'
                              key={`deleted-manifest-mobile-${manifest.manifest_id}-${index}`}
                            >
                              <div className='deleted_manifest_mobile_row'>
                                <div className='deleted_manifest_mobile_label'>
                                  <strong>Contract Type</strong>
                                </div>
                                <div className='deleted_manifest_mobile_value'>
                                  {manifest.abbreviation || '-'}
                                </div>
                              </div>
                              <div className='deleted_manifest_mobile_row'>
                                <div className='deleted_manifest_mobile_label'>
                                  <strong>Contract Number</strong>
                                </div>
                                <div className='deleted_manifest_mobile_value'>
                                  {manifest.contract_number || '-'}
                                </div>
                              </div>
                              <div className='deleted_manifest_mobile_row'>
                                <div className='deleted_manifest_mobile_label'>
                                  <strong>Incident Name</strong>
                                </div>
                                <div className='deleted_manifest_mobile_value'>
                                  {manifest.incident_name || '-'}
                                </div>
                              </div>
                              <div className='deleted_manifest_mobile_row'>
                                <div className='deleted_manifest_mobile_label'>
                                  <strong>Resource Number</strong>
                                </div>
                                <div className='deleted_manifest_mobile_value'>
                                  {manifest.resource_number || '-'}
                                </div>
                              </div>
                              <div className='deleted_manifest_mobile_row'>
                                <div className='deleted_manifest_mobile_label'>
                                  <strong>Date Added</strong>
                                </div>
                                <div className='deleted_manifest_mobile_value'>
                                  {manifest.added_date || '-'}
                                </div>
                              </div>
                              <div className='deleted_manifest_mobile_row'>
                                <div className='deleted_manifest_mobile_label'>
                                  <strong>Date Assigned</strong>
                                </div>
                                <div className='deleted_manifest_mobile_value'>
                                  {manifest.date_assigned || '-'}
                                </div>
                              </div>
                              <div className='deleted_manifest_mobile_row'>
                                <div className='deleted_manifest_mobile_label'>
                                  <strong>Restore</strong>
                                </div>
                                <div className='deleted_manifest_mobile_value'>
                                  <img
                                    src={
                                      require('../assets/icons/restore-icon.svg')
                                        .default
                                    }
                                    alt='Restore Manifest'
                                    title='Restore Manifest'
                                    style={{
                                      cursor: this.state.restoreManifestLoading
                                        ? 'not-allowed'
                                        : 'pointer',
                                      opacity: this.state.restoreManifestLoading
                                        ? 0.5
                                        : 1,
                                      width: '20px',
                                      height: '20px',
                                    }}
                                    onClick={() =>
                                      this.openRestoreManifestModal(
                                        manifest.manifest_id,
                                      )
                                    }
                                  />
                                </div>
                              </div>
                            </div>
                          ),
                        )
                      ) : (
                        <div className='deleted_manifest_mobile_item'>
                          <p>No deleted manifests found</p>
                        </div>
                      )}
                      {this.getDeletedManifestsPaginationHtml()}
                    </div>
                  </div>
                </Accordian>
              )}
            </React.Fragment>
          </div>
        </div>
        <ReactModal
          isOpen={this.state.editROModal}
          onClose={() => this.setState({ editROModal: false })}
        >
          <div id='statusPopup' className='popupModal'>
            <div className='modal-head'>
              <h4 className='modal-title'>Edit Uploaded Resource Order</h4>
            </div>
            <div className='modal-body'>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                }}
              >
                <h5>File: {this.state.selectedUploadedROFile?.file_name}</h5>
                <div className='crew_select_card'>
                  <label>Choose Resources</label>
                  <AsyncSelect
                    cacheOptions
                    loadOptions={this.handleChooseResources}
                    onChange={(selection) =>
                      this.setState({ selectedResource: selection })
                    }
                    isMulti
                    defaultOptions
                    styles={selectStyles}
                    value={this.state.selectedResource}
                  />
                </div>
                <div className='resource_order_form_delete_modal_action'>
                  <button
                    className='button grey'
                    onClick={() => this.setState({ editROModal: false })}
                  >
                    Cancel
                  </button>
                  <button
                    name='save'
                    className={`button ${!this.state.selectedResource?.length ? 'grey' : ''
                      }`}
                    onClick={() =>
                      this.handleEditRO(this.state.selectedUploadedROFile)
                    }
                    disabled={
                      !this.state.selectedResource?.length ||
                      this.state.formSubmission
                    }
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </div>
        </ReactModal>
        <ReactModal
          isOpen={this.state.statusOpen}
          onClose={this.statusCloseModal.bind(this)}
          overlayClassName='deletetPopup deletetPopup-resources'
        >
          {/*<Modal style={"width: 200px"} id="status_popup" className="status_popup" open={this.state.statusOpen} onClose={this.statusCloseModal.bind(this)} little>*/}
          <div id='statusPopup' className='resources-popup'>
            <div className='modal-head'>
              <h4 className='modal-title'>Confirm</h4>
              <img
                alt='close'
                className='closeModal'
                onClick={this.statusCloseModal.bind(this)}
                src={require('../assets/images/close_green.png').default}
              />
            </div>
            <div className='modal-body'>
              <div className='res_delete step1'>
                <label>Do you really want to archive this resource?</label>
                <br />
                <div className='btn_list'>
                  <button
                    className='button'
                    onClick={this.remove.bind(this, true)}
                  >
                    OK
                  </button>
                  <button
                    className='button grey'
                    onClick={this.statusCloseModal.bind(this)}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </div>
          {/*</Modal>*/}
        </ReactModal>
        <ReactModal
          isOpen={this.state.deleteOpen}
          onClose={this.deleteCloseModal.bind(this)}
          overlayClassName='deletetPopup'
        >
          <div id='deletePopup'>
            <div className='modal-head'>
              <h4 className='modal-title'>Confirm</h4>
              <img
                alt='close'
                className='closeModal'
                onClick={this.deleteCloseModal.bind(this)}
                src={require('../assets/images/close_green.png').default}
              />
            </div>
            <div className='modal-body'>
              <div className='status_step step1'>
                <label>
                  Do you really want to remove this manifest? Doing so will
                  remove the assignment history and modify the employees' fire
                  records.
                </label>
                <br />
                <div className='btn_list_popup'>
                  <button
                    className='button grey'
                    onClick={this.deleteCloseModal.bind(this)}
                  >
                    Cancel
                  </button>
                  <button
                    className='button'
                    onClick={this.deleteManifest.bind(this)}
                  >
                    OK
                  </button>
                </div>
              </div>
            </div>
          </div>
        </ReactModal>
        <ReactModal
          isOpen={this.state.displayEditAssignmentConfirmPopup}
          onClose={this.closeEditAssignmentConfirmPopup.bind(this)}
          overlayClassName='closeEditAssignmentPopup'
        >
          <div id='deletePopup'>
            <div className='modal-head'>
              <h4 className='modal-title'>
                Confirm Edit of Assignment History
              </h4>
              <img
                alt='close'
                className='closeModal'
                onClick={this.closeEditAssignmentConfirmPopup.bind(this)}
                src={require('../assets/images/close_green.png').default}
              />
            </div>
            <div className='modal-body'>
              <div className='status_step step1'>
                <label>
                  Please note that any changes to the Date On and Date Off
                  fields will impact the employees' fire history records.
                </label>
                <br />
                <div className='btn_list_popup'>
                  <button
                    className='button grey'
                    onClick={this.closeEditAssignmentConfirmPopup.bind(this)}
                  >
                    Cancel
                  </button>
                  <button
                    className='button'
                    onClick={this.editAssignmentConfirmation.bind(this)}
                  >
                    OK
                  </button>
                </div>
              </div>
            </div>
          </div>
        </ReactModal>
        <ReactModal
          isOpen={this.state.deleteHistoryOpen}
          onClose={this.deleteHistoryCloseModal.bind(this)}
          overlayClassName='deletetPopup'
        >
          <div id='deletePopup'>
            <div className='modal-head'>
              <h4 className='modal-title'>Confirm</h4>
              <img
                alt='close'
                className='closeModal'
                onClick={this.deleteHistoryCloseModal.bind(this)}
                src={require('../assets/images/close_green.png').default}
              />
            </div>

            <div className='modal-body'>
              <div className='status_step step1'>
                <label>
                  Are you sure you want to remove this history? Doing so will
                  affect the employees' fire records.
                </label>
                <br />
                <div className='btn_list_popup'>
                  <button
                    className='button grey'
                    onClick={this.deleteHistoryCloseModal.bind(this)}
                  >
                    Cancel
                  </button>
                  <button className='button' onClick={this.deleteHistory}>
                    OK
                  </button>
                </div>
              </div>
            </div>
          </div>
        </ReactModal>
        <ReactModal
          isOpen={this.state.emailOpen}
          onClose={this.emailCloseModal.bind(this)}
          contentLabel='Minimal Modal Example'
          overlayClassName='emailManifestPopup'
        >
          <div id='statusPopup' className='popupModal'>
            <div className='modal-head'>
              <h4 className='modal-title'>Email Manifest</h4>
              <img
                alt='close'
                className='closeModal'
                onClick={this.emailCloseModal.bind(this)}
                src={require('../assets/images/close_green.png').default}
                onError={this.onImageError.bind(this)}
              />
            </div>
            <div className='modal-body'>
              <div className='mail_div'>
                <div className='left'>
                  <input
                    type='text'
                    className='txtSearchManiEmployees'
                    id='txtSearchManiEmployees'
                    name='Emailkeyword'
                    value={this.state.mailSearchKeyword}
                    placeholder='Search and add employees for sending emails.....'
                    onChange={this.emailChangeFn.bind(this)}
                    autoComplete='off'
                  />
                  {this.state.validManifestMail &&
                    this.state.searchList.length === 0 && (
                      <button
                        className='button add_mail'
                        onClick={this.addManifestEmail}
                      >
                        Add Email
                      </button>
                    )}
                  <ul className={'searchResultUl ' + this.state.hideSearch}>
                    {this.state.searchList}
                  </ul>
                </div>
                <div className='clearFix' />
                <div className='mail-maifest-wrapper'>
                  <div className='mail-manifest wrapper'>
                    <div className='head'>
                      <div className='emp'>Employee</div>
                      <div className='name'>Name</div>
                      <div className='email'>Email</div>
                      <div className='close' />
                    </div>
                    {/* Dispatch */}
                    {this.state.mailListDefault.map((item, index) => {
                      return (
                        <div key={index} className='employee employee_item'>
                          <div className='pic image-holder'>
                            <img
                              src={config.apiUrl + '/' + config.altImg}
                              onError={this.onImageError.bind(this)}
                            />
                          </div>
                          <div className='name'>
                            <span className=''>Dispatch Email</span>
                          </div>
                          <div className='email'>{item}</div>
                          <div
                            className='close-btn'
                            onClick={this.removeDispatchList.bind(this, index)}
                          >
                            <img
                              alt='close'
                              src={
                                require('../assets/images/close_button.png')
                                  .default
                              }
                              onError={this.onImageError.bind(this)}
                            />
                          </div>
                        </div>
                      );
                    })}
                    {/* From List */}
                    {this.state.mailList.map((item, index) => {
                      return (
                        <div className='employee employee_item' key={index}>
                          <div className='pic image-holder'>
                            <img
                              alt={item.first_name + ' ' + item.last_name}
                              className={item.active}
                              src={this.getEmployeePhotoUrl(item.profile_photo)}
                              onError={this.onImageError.bind(this)}
                            />
                          </div>
                          <div className='name'>
                            <span className=''>
                              <span
                                className={item.colorcode + ' color_code'}
                              />
                              {item.first_name + ' ' + item.last_name}
                            </span>
                          </div>
                          <div className='email'>{item.email}</div>
                          <div
                            className='close-btn'
                            onClick={this.removeList.bind(this, index)}
                          >
                            <img
                              alt='close'
                              src={
                                require('../assets/images/close_button.png')
                                  .default
                              }
                              onError={this.onImageError.bind(this)}
                            />
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
                <br />
                <button
                  className='button send_mail'
                  onClick={this.emailManifest.bind(this)}
                >
                  Send
                </button>
              </div>
            </div>
          </div>
        </ReactModal>

        <ReactModal
          isOpen={this.state.viewOpen}
          onClose={this.viewCloseModal.bind(this)}
          contentLabel='Minimal Modal Example'
          overlayClassName='viewManifestPopup'
        >
          <div id='statusPopup' className='popupModal'>
            <div className='modal-head'>
              <h4 className='modal-title'>View Manifest</h4>
              <img
                alt='close'
                className='closeModal'
                onClick={this.viewCloseModal.bind(this)}
                src={require('../assets/images/close_green.png').default}
                onError={this.onImageError.bind(this)}
              />
            </div>
            <div id='viewPdf'>
              <Document file={obj}>
                <Page pageNumber={pageNumber} width={800} />
              </Document>
            </div>
          </div>
        </ReactModal>
        <ReactModal
          isOpen={this.state.deleteROModal}
          onClose={() => this.setState({ deleteROModal: false })}
        >
          <div id='statusPopup' className='popupModal'>
            <div className='modal-head'>
              <h4 className='modal-title'>Confirm Action</h4>
            </div>
            <div className='modal-body'>
              <p>
                {
                  'Deleting RO will remove all the details from corresponding manifests, are you sure want to continue?'
                }
              </p>
              <div className='resource_order_form_delete_modal_action'>
                <button
                  className='button grey'
                  onClick={() => this.setState({ deleteROModal: false })}
                >
                  Cancel
                </button>
                <button
                  name='save'
                  className='button'
                  onClick={() => this.handleDeleteRof(this.state.selectedRO)}
                >
                  Confirm
                </button>
              </div>
            </div>
          </div>
        </ReactModal>
        <ReactModal
          isOpen={this.state.restoreManifestModalOpen}
          onClose={this.closeRestoreManifestModal}
          overlayClassName='deletetPopup'
        >
          <div id='deletePopup'>
            <div className='modal-head'>
              <h4 className='modal-title'>Confirm</h4>
              <img
                alt='close'
                className='closeModal'
                onClick={this.closeRestoreManifestModal}
                src={require('../assets/images/close_green.png').default}
              />
            </div>
            <div className='modal-body'>
              <div className='status_step step1'>
                <label>Do you really want to restore this manifest?</label>
                <br />
                <div className='btn_list_popup'>
                  <button
                    className='button grey'
                    onClick={this.closeRestoreManifestModal}
                  >
                    Cancel
                  </button>
                  <button
                    className='button'
                    onClick={this.handleRestoreManifest}
                  >
                    OK
                  </button>
                </div>
              </div>
            </div>
          </div>
        </ReactModal>
        {this.state.alertPop === true && (
          <AlertPopup
            head={this.state.alertHead}
            message={this.state.alertMsg}
            alertFunction={this.state.alertFunction}
            close={this.closeAlert.bind(this)}
          />
        )}
        <Modal
          isOpen={this?.state?.enableAssignEmployeeModal}
          className='SignatureModal fire_history_assign_modal'
          contentLabel='Example Modal'
        >
          <section>
            <div className='modal-header'>
              <p className='sign_close'>Action Required.</p>
              <div
                className='close-btn'
                onClick={() => this.handleAutoAssignModalClose()}
              >
                <span>&times;</span>
              </div>
            </div>
            <hr />
            <div style={{ padding: '0px 15px' }}>
              <RadioButton
                checked={
                  this?.state?.typeSlug ===
                  FIRE_HISTORY_TYPE_SLUG?.AUTO_ASSIGN_MANIFEST
                }
                value={FIRE_HISTORY_TYPE_SLUG?.AUTO_ASSIGN_MANIFEST}
                onChange={(e) => this.setState({ typeSlug: e?.target?.value })}
                label={'Auto Assign Employees'}
              />
              <RadioButton
                checked={
                  this?.state?.typeSlug ===
                  FIRE_HISTORY_TYPE_SLUG?.MANUAL_ASSIGN_MANIFEST
                }
                value={FIRE_HISTORY_TYPE_SLUG?.MANUAL_ASSIGN_MANIFEST}
                onChange={(e) => this.setState({ typeSlug: e?.target?.value })}
                label={'Assign employees Manually'}
              />
              {this?.state?.typeSlug ===
                FIRE_HISTORY_TYPE_SLUG?.MANUAL_ASSIGN_MANIFEST && (
                  <div>
                    <FireHistoryEmployeeAssignDragAndDrop
                      resourceId={this.state.id}
                      ref={this.sortYourCrewRef}
                    />
                  </div>
                )}
            </div>
            <div>
              <div
                style={{ display: 'flex', justifyContent: 'end', padding: 20 }}
              >
                <button
                  onClick={(event) => {
                    this.handleAutoAssignModalClose();
                    event.preventDefault();
                  }}
                  className='btn  cancel'
                  style={{
                    marginRight: 5,
                    backgroundColor: '#f0f0f0',
                    color: '#202020',
                  }}
                >
                  Cancel
                </button>
                <button
                  type='submit'
                  className='button green'
                  onClick={(e) => this.handleFireHistoryAssignModal(e)}
                >
                  Submit
                </button>
              </div>
            </div>
          </section>
        </Modal>
        <ReactModal
          isOpen={this.state.emailFireCardsOpen}
          onClose={() => this.setState({ emailFireCardsOpen: false })}
        >
          <div id='statusPopup' className='popupModal'>
            <div className='modal-head ro-email-modal-head'>
              <h4 className='modal-title'>Email Fire Cards</h4>
            </div>
            <div className='modal-body ro-modal-body'>
              <CreatableAsyncSelect
                setSelectedEmployees={this.handleSelectEmployees}
                selectedEmployees={this.state.selectedEmployees}
              />
              {!!this.state.selectedEmployees.length && (
                <div className='mail-maifest-wrapper'>
                  <div className='mail-manifest wrapper'>
                    <div className='head'>
                      <div
                        className='name ro-email-modal-name'
                        style={{ fontWeight: 'bold' }}
                      >
                        Name
                      </div>
                      <div className='email' style={{ fontWeight: 'bold' }}>
                        Email
                      </div>
                    </div>
                    {this.state.selectedEmployees?.map((item, index) => {
                      return (
                        <div
                          key={index}
                          className='employee employee_item selected-employee'
                        >
                          <div className='pic image-holder ro-profile-pic-wrapper'>
                            {item.profilePic || item.name ? (
                              <img
                                src={this.getEmployeePhotoUrl(item.profilePic)}
                                onError={this.onImageError.bind(this)}
                                alt='prof-pic'
                              />
                            ) : (
                              ''
                            )}
                          </div>
                          <div className='name'>
                            <span className=''>{item.name}</span>
                          </div>
                          <div className='email'>{item.email}</div>
                          <div className='close-btn'>
                            <img
                              alt='close'
                              src={
                                require('../assets/images/close_button.png')
                                  .default
                              }
                              onClick={() =>
                                this.onClickRemoveEmployeeFromMailList(item)
                              }
                            />
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              )}
              <div className='resource_order_form_delete_modal_action'>
                <button
                  className='button grey'
                  onClick={this.emailFireCardsCloseModal}
                >
                  Cancel
                </button>
                <button
                  name='save'
                  className='button'
                  onClick={this.emailFireCards}
                  disabled={!this.state.selectedEmployees.length}
                >
                  Send
                </button>
              </div>
            </div>
          </div>
        </ReactModal>
        <EmailManifestModal
          isOpen={this.state.emailManifestModalOpen}
          onClose={this.closeEmailManifestModal}
          dispatchMailList={this.state.dispatchMailList}
          mailList={this.state.mailList}
          searchList={this.state.searchList}
          hideSearch={this.state.hideSearch}
          mailSearchKeyword={this.state.mailSearchKeyword}
          validManifestMail={this.state.validManifestMail}
          onEmailChange={this.emailChangeFn}
          onAddEmail={this.addManifestEmail}
          onRemoveEmail={this.removeList}
          onRemoveDispatchEmail={this.removeDispatchList}
          onSendEmail={this.handleSendEmailManifest}
          emailLoader={this.state.commitManifestLoading}
          buttonText='Send Email'
        />
      </div>
    );
  }
}

ResourceDetails.propTypes = {
  match: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
  vehicles: PropTypes.object.isRequired,
  employee: PropTypes.object.isRequired,
  manifest: PropTypes.object.isRequired,
  email: PropTypes.object.isRequired,
  resource: PropTypes.object.isRequired,
  permission: PropTypes.object.isRequired,
  singleresource: PropTypes.object.isRequired,
  assignmentStats: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
  inventory: PropTypes.object.isRequired,
  props: PropTypes.any.isRequired,
  goBack: PropTypes.func.isRequired,
  viewManifest: PropTypes.func.isRequired,
  editManifest: PropTypes.func.isRequired,
  duplicateManifest: PropTypes.func.isRequired,
};

function mapStateToProps(state) {
  const {
    vehicles,
    employee,
    manifest,
    email,
    resource,
    permission,
    singleresource,
    assignmentStats,
    inventory,
    user,
  } = state;
  const { print } = state.manifest;
  return {
    vehicles,
    employee,
    manifest,
    email,
    resource,
    print,
    permission,
    singleresource,
    assignmentStats,
    user,
    inventory,
  };
}

const connectedResourcePage = connect(mapStateToProps)(ResourceDetails);
export { connectedResourcePage as ResourceDetails };
